
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire49a6"];
var parcelRegister = parcelRequire.register;
parcelRegister("dlwiS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "APIProcessingService", {
    enumerable: true,
    get: function() {
        return $di0Ow.APIProcessingService;
    }
});
Object.defineProperty(module.exports, "dataPrefetchService", {
    enumerable: true,
    get: function() {
        return $6873320cce131090$var$_DataPrefetchService.default;
    }
});
Object.defineProperty(module.exports, "displayTuxSurvey", {
    enumerable: true,
    get: function() {
        return $5pdfx.displayTuxSurvey;
    }
});
Object.defineProperty(module.exports, "handleGainsightRoles", {
    enumerable: true,
    get: function() {
        return $5pdfx.handleGainsightRoles;
    }
});
Object.defineProperty(module.exports, "showRolesModalInvite", {
    enumerable: true,
    get: function() {
        return $5pdfx.showRolesModalInvite;
    }
});
Object.defineProperty(module.exports, "showUserConsent", {
    enumerable: true,
    get: function() {
        return $5pdfx.showUserConsent;
    }
});
Object.defineProperty(module.exports, "eventObserver", {
    enumerable: true,
    get: function() {
        return $6873320cce131090$var$_EventObserver.default;
    }
});
Object.defineProperty(module.exports, "getCapabilityWithIconUrl", {
    enumerable: true,
    get: function() {
        return $d81zq.getCapabilityWithIconUrl;
    }
});
Object.defineProperty(module.exports, "getPerformanceMarks", {
    enumerable: true,
    get: function() {
        return $giDZP.getPerformanceMarks;
    }
});
Object.defineProperty(module.exports, "setAccessOverrides", {
    enumerable: true,
    get: function() {
        return $2WCxj.setAccessOverrides;
    }
});
Object.defineProperty(module.exports, "UserInputService", {
    enumerable: true,
    get: function() {
        return $bD3vr.UserInputService;
    }
});
module.exports.updateProfileOnLanguageChange = module.exports.showInitialToasts = module.exports.setupServices = module.exports.getFlagService = module.exports.getBroadcastChannel = module.exports.getAEMOrg = void 0;
parcelRequire("f0ASB");

var $di0Ow = parcelRequire("di0Ow");

var $fi30R = parcelRequire("fi30R");

var $lRoWp = parcelRequire("lRoWp");

var $6873320cce131090$var$_ConnectionMonitorService = $6873320cce131090$var$_interopRequireDefault((parcelRequire("22BGp")));

var $6873320cce131090$var$_DataPrefetchService = $6873320cce131090$var$_interopRequireDefault((parcelRequire("fOiXv")));

var $cpSRd = parcelRequire("cpSRd");

var $5pdfx = parcelRequire("5pdfx");

var $6873320cce131090$var$_EventObserver = $6873320cce131090$var$_interopRequireDefault((parcelRequire("fkM9n")));

var $6873320cce131090$var$_FloodgateService = $6873320cce131090$var$_interopRequireDefault((parcelRequire("aILFS")));

var $3LITL = parcelRequire("3LITL");

var $gigHb = parcelRequire("gigHb");

var $dDEjQ = parcelRequire("dDEjQ");

var $d81zq = parcelRequire("d81zq");

var $giDZP = parcelRequire("giDZP");

var $jVeiz = parcelRequire("jVeiz");

var $ctGaZ = parcelRequire("ctGaZ");

var $9OLey = parcelRequire("9OLey");

var $6873320cce131090$var$_LaunchDarklyService = $6873320cce131090$var$_interopRequireDefault((parcelRequire("kZsRr")));

var $6873320cce131090$var$_PermissionService = $6873320cce131090$var$_interopRequireDefault((parcelRequire("WQJPg")));

var $5FoVO = parcelRequire("5FoVO");

var $6873320cce131090$var$_RecentsService = $6873320cce131090$var$_interopRequireDefault((parcelRequire("9LMog")));

var $2WCxj = parcelRequire("2WCxj");

var $6873320cce131090$var$_supportedBrowsers = $6873320cce131090$var$_interopRequireDefault((parcelRequire("gWRcI")));

var $2qT0f = parcelRequire("2qT0f");

var $bD3vr = parcelRequire("bD3vr");

var $iNslS = parcelRequire("iNslS");
function $6873320cce131090$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ /*
This module encapsulates logic that is required post authentication for code splitting purposes.
 */ const $6873320cce131090$var$isBrowserSupported = ()=>$6873320cce131090$var$_supportedBrowsers.default.test(window.navigator.userAgent);
const $6873320cce131090$var$showInitialToasts = ({ getComponentContext: getComponentContext, metrics: metrics })=>{
    const url = new URL(`${window.location.origin}${(0, $jVeiz.hashToPath)()}`);
    const redirectToast = url.searchParams.get("redirectToast");
    if (redirectToast) {
        getComponentContext?.().showToast(redirectToast);
        const path = (0, $jVeiz.removeQueryParamsFromPath)((0, $jVeiz.hashToPath)(), [
            "redirectToast"
        ]);
        (0, $2qT0f.updatePath)({
            path: path
        }, true);
    } // Check if the current browser is supported and show a message if it's not.
    if (!$6873320cce131090$var$isBrowserSupported()) {
        metrics.warn("This browser is not supported.");
        getComponentContext?.().showToast("browserlistWarning");
    }
};
/**
 * Get the org of the current instance via AEM discovery endpoint using the
 * discovery service. Since this is also used to generate the session, this
 * is the only time it is needed to run on page load. Future calls will pull
 * from discovery cache.
 * @returns AEM discovery promise.
 */ module.exports.showInitialToasts = $6873320cce131090$var$showInitialToasts;
const $6873320cce131090$var$getAEMOrg = async (solutions, environment)=>{
    const aemConfig = solutions.find(({ appId: appId })=>appId === "aemshell");
    if (aemConfig) {
        const { appId: appId, sandbox: { sources: sources }, sections: sections, serviceCode: serviceCode, session: sessionConfig } = aemConfig;
        const source = sources[environment];
        return new $cpSRd.DiscoveryService().getSourceFromDiscovery({
            ...source,
            discovery: `${window.location.origin}${source.discovery}`
        }, {
            imsOrg: "",
            imsProfile: {
                userId: ""
            }
        }, {
            appEnv: environment,
            appId: appId,
            basePath: "/aem",
            history: $ctGaZ.HISTORY.SERVER,
            sections: sections,
            serviceCode: serviceCode,
            sessionConfig: sessionConfig
        });
    }
};
module.exports.getAEMOrg = $6873320cce131090$var$getAEMOrg;
const $6873320cce131090$var$onAuthBroadcast = async ({ data: data }, auth, showSpinner, metrics)=>{
    const sessionId = (0, $dDEjQ.getBootstrap)().getSid();
    switch(data.message){
        case $fi30R.AuthMessages.LOGOUT:
            showSpinner();
            metrics.event("AuthBroadcast.signOut"); // Moves Main component to a wait state in order to remove sandbox.
            // This will prevent an active iframe from blocking navigation.
            await $9OLey.Internal.flush();
            auth.signOut();
            break;
        case $fi30R.AuthMessages.LOGIN:
            // If session has changed refresh browser.
            if (sessionId && sessionId !== data.sessionId) {
                metrics.event("Auth.sessionReplaced", {
                    newSession: data.sessionId,
                    oldSession: sessionId
                });
                await Promise.all([
                    $9OLey.Internal.flush(),
                    // This will prevent an active iframe from blocking navigation.
                    showSpinner(),
                    // To prevent this, get a new token (Against new session) before refreshing the page
                    // IMSlib stores it in session storage, so after reload it will be used by Shell.
                    auth.refreshToken()
                ]);
                (0, $lRoWp.reload)({
                    initiator: "CoreLogin",
                    reason: "Login Broadcast"
                });
            }
            break;
        default:
            data.message && metrics.warn(`Unknown auth message: ${data.message}`);
    }
};
const $6873320cce131090$var$getBroadcastChannel = (showSpinner, core)=>{
    const authChannel = new BroadcastChannel("auth");
    core.authPromise.then((auth)=>authChannel.addEventListener("message", async (event)=>$6873320cce131090$var$onAuthBroadcast(event, auth, showSpinner, core.metrics)));
    return authChannel;
};
module.exports.getBroadcastChannel = $6873320cce131090$var$getBroadcastChannel;
const $6873320cce131090$var$addAuthListeners = (core)=>{
    // Listen for token updates on the auth instance and update the state with
    // the new profile and token data.
    core.authPromise.then((auth)=>{
        auth.on("auth.token.change", async ({ clientId: clientId, isExcClient: isExcClient, profile: profile, scope: scope, token: token, userId: userId })=>{
            if (isExcClient) {
                // Updates the token in exc-app/network.
                core.configureNetwork(null, true);
                core.setState({
                    accessToken: token,
                    profile: profile
                });
            } else {
                // Stores the new token information for the next cache pull.
                const key = (0, $lRoWp.getTokenKey)(clientId, scope, userId);
                auth.customTokenService?.updateCachedTokens(key, {
                    profile: profile,
                    token: token
                });
                core.onCustomTokenChange(profile, token);
            }
        });
        auth.on("auth.rideError", core.showRideError);
    });
};
const $6873320cce131090$var$getFlagService = (provider)=>provider === $5FoVO.PROVIDERS.LAUNCH_DARKLY ? $6873320cce131090$var$_LaunchDarklyService.default : $6873320cce131090$var$_FloodgateService.default;
module.exports.getFlagService = $6873320cce131090$var$getFlagService;
const $6873320cce131090$var$setupServices = (core)=>{
    const services = {
        dataPrefetchService: $6873320cce131090$var$_DataPrefetchService.default,
        discoveryService: new $cpSRd.DiscoveryService(),
        getFlagService: $6873320cce131090$var$getFlagService,
        permissionService: $6873320cce131090$var$_PermissionService.default,
        recentsService: new $6873320cce131090$var$_RecentsService.default($6873320cce131090$var$_DataPrefetchService.default, core.updateLastRecent)
    }; // Add listeners to render the ShellNetworkError component as needed
    $6873320cce131090$var$_ConnectionMonitorService.default.on("connected", ()=>core.setState({
            showNetworkDisconnected: null
        }));
    $6873320cce131090$var$_ConnectionMonitorService.default.on("offline", ()=>core.setState({
            showNetworkDisconnected: "offline"
        }));
    $6873320cce131090$var$_ConnectionMonitorService.default.on("unstable", ()=>core.setState({
            showNetworkDisconnected: "unstable"
        }));
    core.nonSupportedBrowser = !$6873320cce131090$var$isBrowserSupported();
    core.services = services;
    $6873320cce131090$var$addAuthListeners(core);
    core.metrics.event("PostAuth.loaded");
};
module.exports.setupServices = $6873320cce131090$var$setupServices;
const $6873320cce131090$var$updateProfileOnLanguageChange = async (core, locale, profile, firstCall = true)=>{
    try {
        const { imsExtendedAccountClusterData: cluster } = await (0, $3LITL.getAccountCluster)({});
        if (cluster?.preferredLanguages) {
            if ((0, $gigHb.getBestSupportedLocale)([
                locale
            ], $gigHb.SUPPORTED_LOCALES) !== (0, $gigHb.getBestSupportedLocale)(cluster.preferredLanguages, $gigHb.SUPPORTED_LOCALES)) {
                firstCall ? (0, $iNslS.wait)(15000).then(()=>$6873320cce131090$var$updateProfileOnLanguageChange(core, locale, profile, false)) : core.metrics.warn("Account cluster locale is incorrect", {
                    accountClusterLocale: cluster.preferredLanguages[0],
                    currentLocale: locale
                });
                return;
            }
            const newProfile = {
                ...profile,
                preferred_languages: cluster.preferredLanguages
            };
            core.authPromise.then((auth)=>auth.updateProfile(newProfile));
            core.setState({
                profile: newProfile
            });
        }
    } catch (err) {
        core.metrics.error("Error fetching new account cluster", err);
    }
};
module.exports.updateProfileOnLanguageChange = $6873320cce131090$var$updateProfileOnLanguageChange;

});
parcelRegister("f0ASB", function(module, exports) {
(function(global) {
    var channels = [];
    function BroadcastChannel(channel) {
        var $this = this;
        channel = String(channel);
        var id = "$BroadcastChannel$" + channel + "$";
        channels[id] = channels[id] || [];
        channels[id].push(this);
        this._name = channel;
        this._id = id;
        this._closed = false;
        this._mc = new MessageChannel();
        this._mc.port1.start();
        this._mc.port2.start();
        global.addEventListener("storage", function(e) {
            if (e.storageArea !== global.localStorage) return;
            if (e.newValue == null || e.newValue === "") return;
            if (e.key.substring(0, id.length) !== id) return;
            var data = JSON.parse(e.newValue);
            $this._mc.port2.postMessage(data);
        });
    }
    BroadcastChannel.prototype = {
        // BroadcastChannel API
        get name () {
            return this._name;
        },
        postMessage: function(message) {
            var $this = this;
            if (this._closed) {
                var e = new Error();
                e.name = "InvalidStateError";
                throw e;
            }
            var value1 = JSON.stringify(message);
            // Broadcast to other contexts via storage events...
            var key = this._id + String(Date.now()) + "$" + String(Math.random());
            global.localStorage.setItem(key, value1);
            setTimeout(function() {
                global.localStorage.removeItem(key);
            }, 500);
            // Broadcast to current context via ports
            channels[this._id].forEach(function(bc) {
                if (bc === $this) return;
                bc._mc.port2.postMessage(JSON.parse(value1));
            });
        },
        close: function() {
            if (this._closed) return;
            this._closed = true;
            this._mc.port1.close();
            this._mc.port2.close();
            var index = channels[this._id].indexOf(this);
            channels[this._id].splice(index, 1);
        },
        // EventTarget API
        get onmessage () {
            return this._mc.port1.onmessage;
        },
        set onmessage (value){
            this._mc.port1.onmessage = value;
        },
        addEventListener: function() {
            return this._mc.port1.addEventListener.apply(this._mc.port1, arguments);
        },
        removeEventListener: function() {
            return this._mc.port1.removeEventListener.apply(this._mc.port1, arguments);
        },
        dispatchEvent: function() {
            return this._mc.port1.dispatchEvent.apply(this._mc.port1, arguments);
        }
    };
    global.BroadcastChannel = global.BroadcastChannel || BroadcastChannel;
})(self);

});

parcelRegister("di0Ow", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.APIProcessingService = module.exports.SECONDARY_IGNORED_EVENTS = module.exports.SECONDARY_PROXY_CONFIGS = void 0;

var $dXqQN = parcelRequire("dXqQN");

var $0d9307c0a9dea52c$var$_CacheService = $0d9307c0a9dea52c$var$_interopRequireDefault((parcelRequire("frs9M")));

var $0d9307c0a9dea52c$var$_AppHtmlService = $0d9307c0a9dea52c$var$_interopRequireDefault((parcelRequire("ljK83")));

var $36K1U = parcelRequire("36K1U");

var $iNslS = parcelRequire("iNslS");

var $9y8DT = parcelRequire("9y8DT");

var $fnuc3 = parcelRequire("fnuc3");

var $0d9307c0a9dea52c$var$_DataPrefetchService = $0d9307c0a9dea52c$var$_interopRequireDefault((parcelRequire("fOiXv")));

var $0d9307c0a9dea52c$var$_EventObserver = $0d9307c0a9dea52c$var$_interopRequireDefault((parcelRequire("fkM9n")));

var $dDEjQ = parcelRequire("dDEjQ");

var $loe8n = parcelRequire("loe8n");

var $3Zpnv = parcelRequire("3Zpnv");

var $hCG2Z = parcelRequire("hCG2Z");

var $jVeiz = parcelRequire("jVeiz");

var $ctGaZ = parcelRequire("ctGaZ");

var $hCZmk = parcelRequire("hCZmk");

var $0d9307c0a9dea52c$var$_metrics = $0d9307c0a9dea52c$var$_interopRequireDefault((parcelRequire("17AVh")));

var $7CZdW = parcelRequire("7CZdW");

var $0d9307c0a9dea52c$var$_PermissionService = $0d9307c0a9dea52c$var$_interopRequireDefault((parcelRequire("WQJPg")));

var $5FoVO = parcelRequire("5FoVO");

var $lRoWp = parcelRequire("lRoWp");

var $0d9307c0a9dea52c$var$_SessionService = $0d9307c0a9dea52c$var$_interopRequireDefault((parcelRequire("7Jeo0")));

var $iJaYo = parcelRequire("iJaYo");

var $2qT0f = parcelRequire("2qT0f");
function $0d9307c0a9dea52c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0d9307c0a9dea52c$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $0d9307c0a9dea52c$var$_getRequireWildcardCache = function() {
        return cache;
    };
    return cache;
}
function $0d9307c0a9dea52c$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $0d9307c0a9dea52c$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $0d9307c0a9dea52c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
const $0d9307c0a9dea52c$var$scopedEvents = {
    helpCenter: $iNslS.Events.CUSTOM_HELP_BUTTON_CLICK,
    helpCenterResource: $iNslS.Events.CUSTOM_HELP_BUTTON_CLICK,
    userProfile: $iNslS.Events.CUSTOM_PROFILE_BUTTON_CLICK
};
const $0d9307c0a9dea52c$var$validConfigKeys = new Set([
    "appContainer",
    "coachMark",
    "customEnvLabel",
    "customSearch",
    "digitalData",
    "helpCenter",
    "hero",
    "modal",
    "nps",
    "onCustomButtonClick",
    "showLanguagePicker",
    "showRolesPicker",
    "sidenav/visible",
    "sidenav/collapsed",
    "sidenav/config",
    "solution"
]);
const $0d9307c0a9dea52c$var$SECONDARY_PROXY_CONFIGS = [
    "spinner"
];
module.exports.SECONDARY_PROXY_CONFIGS = $0d9307c0a9dea52c$var$SECONDARY_PROXY_CONFIGS;
const $0d9307c0a9dea52c$var$SECONDARY_IGNORED_EVENTS = [
    $iNslS.Events.AFTER_PRINT_HANDLER,
    $iNslS.Events.BEFORE_PRINT_HANDLER,
    $iNslS.Events.COMPONENT_OPEN,
    $iNslS.Events.CUSTOM_HERO_CLICK,
    $iNslS.Events.HISTORY,
    $iNslS.Events.OPEN_HELP_CENTER,
    $iNslS.Events.PRINT_NOW,
    $iNslS.Events.SKIP_MENU_SET_LIST,
    $iNslS.Events.TOAST_SUPRESSED,
    $iNslS.Events.TRIGGER_NPS
];
module.exports.SECONDARY_IGNORED_EVENTS = $0d9307c0a9dea52c$var$SECONDARY_IGNORED_EVENTS;



class $0d9307c0a9dea52c$var$APIProcessingService {
    constructor(messageService){
        $0d9307c0a9dea52c$var$_defineProperty(this, "metrics", $0d9307c0a9dea52c$var$_metrics.default.create("exc.core.services.APIProcessingService"));
        $0d9307c0a9dea52c$var$_defineProperty(this, "messageService", void 0);
        $0d9307c0a9dea52c$var$_defineProperty(this, "warnedConfigs", new Set());
        $0d9307c0a9dea52c$var$_defineProperty(this, "blockNavigationService", void 0);
        $0d9307c0a9dea52c$var$_defineProperty(this, "pendindDataRequests", {});
        $0d9307c0a9dea52c$var$_defineProperty(this, "queuedDataEvents", []);
        $0d9307c0a9dea52c$var$_defineProperty(this, "toastsSupressed", []);
        $0d9307c0a9dea52c$var$_defineProperty(this, "searchOpenState", void 0);
        $0d9307c0a9dea52c$var$_defineProperty(this, "sendDeprecationWarning", (key, app)=>{
            const { context: context } = app;
            if (!this.warnedConfigs.has(key)) {
                this.metrics.event("DeprecationWarning", key, {
                    level: $hCZmk.Level.WARN
                });
                if (context.environment !== "prod") this.metrics.warn(`This method of configuring "${key}" is deprecated. ` + `Please use the up-to-date method. For more information, ` + `visit https://git.corp.adobe.com/exc/unified-shell/wiki/Unified-Shell-Deprecation-Guide-and-Statuses`);
                this.warnedConfigs.add(key);
            }
        });
        $0d9307c0a9dea52c$var$_defineProperty(this, "appApiHandler", (value, app)=>{
            const { context: { shellInfo: shellInfo } } = app;
            const { data: data = "" } = value;
            if (!this.queueEvent(!!shellInfo, this.appApiHandler, value)) {
                const { landingpage: landingpage, services: services, solutions: solutions } = shellInfo;
                const response = services.concat(solutions).concat(landingpage).find((l)=>l.appId === data);
                this.fulfillEvent(value, response, app, false, `${data} not found`);
            }
        });
        $0d9307c0a9dea52c$var$_defineProperty(this, "aemInstanceHandler", async (value, app)=>{
            const { data: { filterByRepoParam: filterByRepoParam = false } = {} } = value;
            const { context: { imsOrg: imsOrg } } = app;
            if (!this.queueEvent(!!imsOrg, this.aemInstanceHandler, value)) try {
                const instanceMap = await Promise.resolve().then(function() {
                    return (parcelRequire("hFGrB"));
                }).then((res)=>$0d9307c0a9dea52c$var$_interopRequireWildcard(res)).then(({ getAEMInstances: getAEMInstances })=>getAEMInstances());
                const repo = (0, $hCG2Z.getQueryParams)()["repo"];
                let instances = (instanceMap[imsOrg] || []).map(({ domain: domain, title: title })=>({
                        domain: domain,
                        matchesRepoParam: domain === repo,
                        title: title
                    }));
                if (filterByRepoParam) instances = instances.filter(({ matchesRepoParam: matchesRepoParam })=>matchesRepoParam);
                this.fulfillEvent(value, instances, app);
            } catch (err) {
                this.rejectEvent(value, err, app);
            }
        });
        $0d9307c0a9dea52c$var$_defineProperty(this, "appCacheHandler", async (value, app)=>{
            const { appId: appId, context: context, solutionConfig: { sharedCaches: sharedCaches } } = app;
            const { imsOrg: imsOrg, sandbox: sandbox, subOrg: subOrg } = context;
            const { data: data, method: method } = value;
            const { scope: scope = $9y8DT.CacheScope.ORG, sharedCache: sharedCache } = data || {};
            let params = {
                ...data,
                appId: appId,
                context: context
            };
            const canProcess = !!(imsOrg && (scope !== $9y8DT.CacheScope.SANDBOX || sandbox) && (scope !== $9y8DT.CacheScope.SUBORG || subOrg));
            if (!this.queueEvent(canProcess, this.appCacheHandler, value)) {
                if (sharedCache && sharedCache !== appId) {
                    if (!(sharedCaches || []).includes(sharedCache)) {
                        // Application is not allowed to access this shared cache.
                        this.rejectEvent(value, `${appId} is not allowed to access shared cache "${sharedCache}"`, app);
                        return;
                    }
                    params = {
                        ...params,
                        appId: sharedCache,
                        sharedCache: undefined
                    };
                }
                try {
                    let response;
                    switch(method){
                        case "DELETE":
                            await $0d9307c0a9dea52c$var$_CacheService.default.delete(params);
                            break;
                        case "GET":
                            response = await $0d9307c0a9dea52c$var$_CacheService.default.get(params);
                            break;
                        case "POST":
                            await $0d9307c0a9dea52c$var$_CacheService.default.set(params);
                            break;
                    }
                    this.fulfillEvent(value, response, app);
                } catch (err) {
                    this.rejectEvent(value, err, app);
                }
            }
        });
        $0d9307c0a9dea52c$var$_defineProperty(this, "consentApiHandler", async (value, app)=>{
            const { context: { userConsent: userConsent } } = app;
            if (!this.queueEvent(!!userConsent, this.consentApiHandler, value)) this.fulfillEvent(value, userConsent, app, false, `${value.data} not found`);
        });
        $0d9307c0a9dea52c$var$_defineProperty(this, "modulesApiHandler", (value, app)=>{
            const { data: data } = value;
            const { solutions: solutions } = window.config;
            const allParams = (0, $hCG2Z.getQueryParams)();
            let modules = Object.keys(solutions).reduce((obj, name)=>({
                    ...obj,
                    [name]: {
                        liveVersion: solutions[name].liveVersion
                    }
                }), {});
            if (data && data !== "*") {
                const appsToReturn = typeof data === "string" ? [
                    data
                ] : data;
                modules = appsToReturn.reduce((obj, name)=>({
                        ...obj,
                        [name]: modules[name]
                    }), {});
            }
            Object.keys(allParams).forEach((param)=>{
                if (param.endsWith("_version")) {
                    const [name] = param.split("_version");
                    modules[name] && (modules[name] = {
                        ...modules[name],
                        liveVersion: allParams[param]
                    });
                }
            });
            this.fulfillEvent(value, modules, app);
        });
        $0d9307c0a9dea52c$var$_defineProperty(this, "dataPrefetchHandler", async (value, app)=>{
            const { appId: appId, context: context } = app;
            const { key: key, method: method, options: options } = value;
            if (!this.queueEvent(!$0d9307c0a9dea52c$var$_DataPrefetchService.default.isContextMissing(key, context), this.dataPrefetchHandler, value)) try {
                let response = {};
                if (method === "GET") response = await $0d9307c0a9dea52c$var$_DataPrefetchService.default.getData(key, context, appId, options);
                this.fulfillEvent(value, response, app);
            } catch (err) {
                this.rejectEvent(value, err, app);
            }
        });
        $0d9307c0a9dea52c$var$_defineProperty(this, "featureFlagsHandler", async (value, app)=>{
            const context = {
                ...app.context
            };
            const { accessOverridesEnabled: accessOverridesEnabled, getFlagService: getFlagService, hashedAuthId: hashedAuthId } = context;
            const { data: data } = value; // Ensure the context is there and the helper is available before proceeding
            if (!getFlagService) return;
            const flagService = getFlagService(data.provider || $5FoVO.PROVIDERS.LAUNCH_DARKLY); // The original API receives an array of the requested projectIds from LaunchDarkly
            // The new, extended API supports an an object with feature flag provider ids
            // and context options
            // Either way, since an array is an object in javascript, destructuring is valid
            // because the variables will be undefined if the object is not present
            const { config: config, sandbox: sandbox } = data;
            const providerIds = "clientIds" in data ? data.clientIds : data.projectIds; // Then this check will work to handle the feature flag provider ids we need
            const projects = Array.isArray(data) ? data : providerIds; // Support context values included in the API
            sandbox && (context.sandbox = sandbox);
            let response;
            if (!this.queueEvent(!flagService.isContextMissing(projects, context), this.featureFlagsHandler, value) && flagService) {
                try {
                    response = await flagService.getFeatureFlags(projects, context, config); // If access overrides are enabled, we update the response to include any overrides
                    if (accessOverridesEnabled && response) {
                        const overrideKey = data?.provider === $5FoVO.PROVIDERS.FLOODGATE ? $dXqQN.ACCESS_TYPES.FLOODGATE : $dXqQN.ACCESS_TYPES.FEATURE_FLAGS;
                        response = (0, $dXqQN.overrideApiFeatureFlags)(response, projects, hashedAuthId, overrideKey);
                    }
                } catch (err) {
                    return this.rejectEvent(value, err, app);
                }
                this.fulfillEvent(value, response, app);
            }
        });
        $0d9307c0a9dea52c$var$_defineProperty(this, "sessionHandler", async (value, app)=>{
            const { context: context, solutionConfig: { session: sessionConfig } } = app;
            const { discoveryService: discoveryService, imsOrg: imsOrg, imsProfile: imsProfile } = context;
            const { data: session, method: method } = value;
            if (!sessionConfig) return this.rejectEvent(value, "Session not configured", app);
            if (!this.queueEvent(!!(discoveryService && imsProfile && imsOrg), this.sessionHandler, value) && discoveryService) try {
                let response;
                const options = discoveryService.getDiscoveryOptions(app);
                switch(method){
                    case "DELETE":
                        await $0d9307c0a9dea52c$var$_SessionService.default.invalidateSession(session, context, options);
                        break;
                    case "GET":
                        {
                            const source = (0, $loe8n.getDiscoverySource)(app);
                            response = await $0d9307c0a9dea52c$var$_SessionService.default.getSession(context, options, source, discoveryService);
                            break;
                        }
                    case "POST":
                        await $0d9307c0a9dea52c$var$_SessionService.default.setSession(session, context, options);
                        break;
                }
                this.fulfillEvent(value, response, app);
            } catch (err) {
                this.rejectEvent(value, err, app);
            }
        });
        $0d9307c0a9dea52c$var$_defineProperty(this, "srcDocHandler", async (value, app)=>{
            const { appId: appId } = app;
            const { data: options } = value;
            const { spaName: spaName } = options;
            const spaDetails = (0, $loe8n.getSpaApp)(spaName);
            if (!spaDetails?.liveVersion) return this.rejectEvent(value, `Can not find '${spaName}' live version information`, app);
            try {
                const appHtmlService = new $0d9307c0a9dea52c$var$_AppHtmlService.default((0, $dDEjQ.getBootstrap)().activeCdn);
                const html = await appHtmlService.getHtml({
                    ...options,
                    appId: appId,
                    liveVersion: spaDetails.liveVersion
                });
                return this.fulfillEvent(value, html, app);
            } catch (err) {
                this.metrics.error("Failed to get SPA HTML", {
                    error: (0, $iNslS.getErrorMessage)(err),
                    liveVersion: spaDetails.liveVersion,
                    spaName: spaName
                });
                return this.rejectEvent(value, `Failed to fetch '${spaName}' HTML`, app);
            }
        });
        $0d9307c0a9dea52c$var$_defineProperty(this, "permissionsHandler", async (value, app)=>{
            const { appId: appId, context: { imsProfile: imsProfile, imsOrg: imsOrg, sandbox: sandbox, sandboxesAvailable: sandboxesAvailable }, solutionConfig: { urlContext: urlContext } } = app;
            if (urlContext?.key !== "sandbox" || !sandboxesAvailable) return this.rejectEvent(value, "Permissions Service is only available to apps and orgs with PALM sandboxes enabled", app);
            if (!this.queueEvent(!!(imsProfile && sandbox), this.permissionsHandler, value)) {
                const { data: data, id: id } = value;
                try {
                    const response = await $0d9307c0a9dea52c$var$_PermissionService.default.get(data, imsOrg, sandbox);
                    this.metrics.info(`Sandbox: PermissionsHandler received response for ${id}, appId: ${appId}`);
                    this.fulfillEvent(value, response, app);
                } catch  {
                    this.metrics.error(`Sandbox: PermissionsHandler failed to get response for ${id}, appId: ${appId}`);
                    this.rejectEvent(value, "Unable to fetch permissions", app);
                }
            }
        });
        $0d9307c0a9dea52c$var$_defineProperty(this, "getPulseService", async (app)=>{
            const { context: { environment: env, imsToken: accessToken } } = app;
            const queryParams = (0, $hCG2Z.getQueryParams)();
            const { default: { getPulseService: getPulseService } } = await Promise.resolve().then(function() {
                return (parcelRequire("kV60S"));
            }).then((res)=>$0d9307c0a9dea52c$var$_interopRequireWildcard(res));
            return getPulseService({
                authInfo: {
                    accessToken: accessToken
                },
                env: env,
                queryParams: queryParams
            });
        });
        $0d9307c0a9dea52c$var$_defineProperty(this, "pulseHandler", async (value, app)=>{
            const { appId: appId, context: { imsProfile: imsProfile, imsOrg: imsOrgId } } = app;
            const { data: data, method: method } = value;
            if (!this.queueEvent(!!(imsProfile && imsOrgId), this.pulseHandler, value)) try {
                const userProfile = imsProfile;
                const pulseService = await this.getPulseService(app);
                const response = await pulseService.sendNotifications({
                    appId: appId,
                    data: data,
                    imsOrgId: imsOrgId,
                    method: method,
                    userProfile: userProfile
                });
                this.fulfillEvent(value, response, app);
            } catch (err) {
                this.metrics.error("Sandbox: PulseHandler failed to send notifications", {
                    error: (0, $iNslS.getErrorMessage)(err)
                });
                this.rejectEvent(value, "Failed to send notifications", app);
            }
        });
        $0d9307c0a9dea52c$var$_defineProperty(this, "settingsHandler", async (value, app)=>{
            const { appId: appId, context: { imsProfile: imsProfile, settingsService: settingsService } } = app;
            const { data: data, id: id, method: method } = value;
            if (!this.queueEvent(!!(imsProfile && settingsService), this.settingsHandler, value)) {
                this.metrics.info(`Sandbox: SettingsHandler received request for ${id}, appId: ${appId}`);
                try {
                    const response = await settingsService.settingsHandler(data, method);
                    this.metrics.info(`Sandbox: SettingsHandler received response for ${id}, appId: ${appId}`);
                    this.fulfillEvent(value, response, app);
                } catch  {
                    this.metrics.error(`Sandbox: SettingsHandler failed for ${id}, appId: ${appId}`);
                    this.rejectEvent(value, "Settings call failed", app);
                }
            }
        });
        $0d9307c0a9dea52c$var$_defineProperty(this, "jiraFeedbackHandler", async (feedbackConfig, app)=>{
            const { context: { environment: environment, imsInfo: imsInfo, sandbox: sandbox, subOrg: subOrg } } = app;
            const jira = (await Promise.resolve().then(function() {
                return (parcelRequire("gORGm"));
            }).then((res)=>$0d9307c0a9dea52c$var$_interopRequireWildcard(res))).default;
            jira.createJiraFeedback(feedbackConfig, {
                ...imsInfo,
                environment: environment,
                sandbox: sandbox,
                subOrg: subOrg
            });
        });
        this.messageService = messageService;
        this.blockNavigationService = (0, $36K1U.getBlockNavigation)(); // Pulls the existing error toasts from local storage. `this.toastsSupressed`
        // is updated in real-time and then pushed back into storage. This protects
        // us against concurrency issues.
        $iJaYo.storage.local.get("shellToasts").then((storedToasts)=>this.toastsSupressed = storedToasts || []);
    }
    /**
   * Unblocks navigation (If blocked).
   */ unblockNavigation() {
        this.blockNavigationService.blockNavigation(false);
    }
    /**
   * Send configuration from the iframe (AppSandbox) to Unified Shell (Core component).
   * @param config - Updated Configuration
   * @param app - AppSandbox object.
   */ setProxiedConfiguration(config, app) {
        const { context: context, metricsAppId: metricsAppId } = app;
        if (app.secondary) // Secondary (SandboxInner) are restricted to certain configs only.
        config = $0d9307c0a9dea52c$var$SECONDARY_PROXY_CONFIGS.reduce((accumulator, key)=>{
            key in config && (accumulator[key] = config[key]);
            return accumulator;
        }, {});
         // if digitalData is present, convert back to object before sending to metrics
        config.digitalData && (config.digitalData = JSON.parse(config.digitalData));
        this.metrics.event("Sandbox.setProxiedConfiguration", config);
        Object.keys(config).forEach((key)=>{
            const value = config[key];
            switch(key){
                case "customButtons":
                    config.onCustomButtonClick = (clickValue)=>this.messageService.sendMessage({
                            type: $0d9307c0a9dea52c$var$scopedEvents[clickValue.scope],
                            value: clickValue
                        }, app);
                    break;
                case "feedback":
                    if (value.type === "custom") app.customFeedback = true;
                    break;
                case "logoutUrl":
                    context.setLogoutUrl(typeof value === "string" ? {
                        url: value
                    } : value);
                    break;
                case "preventDefaultCombos":
                    $0d9307c0a9dea52c$var$_EventObserver.default.setPreventDefaultCombos(value);
                    break;
                case "pulse/button":
                    config.pulse = {
                        ...config.pulse || {},
                        button: {
                            callback: ()=>this.messageService.sendMessage({
                                    type: $iNslS.Events.PULSE_BUTTON
                                }, app),
                            label: value.label
                        }
                    };
                    break;
                case "pulse/count":
                    config.pulse = {
                        ...config.pulse || {},
                        count: value
                    };
                    break;
                case "sidebar":
                    // This is now deprecated in favor of the sidenav config, which should be used instead.
                    // Remove this once all solutions have been transitioned to sidenav.
                    value?.config?.menu && (0, $fnuc3.cleanSidenavUrls)(value.config.menu, app);
                    break;
                case "sidenav/config":
                    value?.menu && (0, $fnuc3.cleanSidenavUrls)(value.menu, app);
                    break;
                case "solution":
                    config.hero = value;
                    break;
                case "spinner":
                    app.setSpinner(value);
                    break;
                case "subOrgs":
                    this.metrics.info(`subOrgs set by solution ${metricsAppId}`);
                    break;
                case "title":
                    app.titleService?.update(value);
                    break;
                case "unloadPromptMessage":
                    this.blockNavigationService.unloadPromptMessage = value;
                    break;
                case "workspaces":
                    value.forEach((menu)=>(0, $fnuc3.updateWorkspaceURL)(menu, app));
                    break;
                default:
                    if (!$0d9307c0a9dea52c$var$validConfigKeys.has(key)) {
                        // Delete any keys that do not match the above keys or keys in valid set so
                        // Core state isn't filled with unneeded states and states don't get overridden
                        delete config[key];
                        this.metrics.info(`Sandbox: unknown shell configuration ${key}`);
                    }
            }
        }); // secondary sandboxes (i.e. SandboxInner) should not update Unified Shell config
        app.secondary || context.setConfigStates(config);
    }
    /**
   * Process and respond to messages coming from the iframe (AppSandbox).
   * @param type - Message type
   * @param value - Message payload
   * @param app - AppSandbox object.
   * @param lastConfiguration - Last configuration sent to the iframe.
   */ handleMessage(type, value, app, lastConfiguration) {
        const { appId: appId, context: context, metricsAppId: metricsAppId, solutionConfig: { hideTenant: hideTenant } } = app;
        const sendMessage = (message)=>this.messageService.sendMessage(message, app);
        if (app.secondary && $0d9307c0a9dea52c$var$SECONDARY_IGNORED_EVENTS.includes(type)) // These events do not apply to secondary sandboxes (i.e. SandboxInner), ignore.
        return;
        switch(type){
            case $iNslS.Events.ACTIVE:
                $0d9307c0a9dea52c$var$_EventObserver.default.handleIframeActive();
                break;
            case $iNslS.Events.AEM_INSTANCES:
                this.aemInstanceHandler(value, app);
                break;
            case $iNslS.Events.AFTER_PRINT_HANDLER:
                context.setConfigStates({
                    afterPrintHandler: ()=>sendMessage({
                            type: $iNslS.Events.AFTER_PRINT_HANDLER
                        })
                });
                break;
            case $iNslS.Events.AI_MESSAGE:
                document.dispatchEvent(new CustomEvent("aiMessageIncoming", {
                    detail: value
                }));
                break;
            case $iNslS.Events.APP_CACHE:
                this.appCacheHandler(value, app);
                break;
            case $iNslS.Events.APP_DATA:
                this.appApiHandler(value, app);
                break;
            case $iNslS.Events.AUTH_EXPIRATION:
                (0, $lRoWp.queueMetrics)("API Processing Auth Expiration", {
                    data: {
                        event: "AUTH_EXPIRATION",
                        value: value
                    }
                });
                context.onSignOut(true, "User timed out");
                break;
            case $iNslS.Events.BEFORE_PRINT_HANDLER:
                context.setConfigStates({
                    beforePrintHandler: ()=>sendMessage({
                            type: $iNslS.Events.BEFORE_PRINT_HANDLER
                        })
                });
                break;
            case $iNslS.Events.BLOCK_NAVIGATION:
                // Prevent navigation blocking for tenantless solutions since it is not supported
                value && !hideTenant && this.blockNavigationService.blockNavigation(value.enabled, value.options);
                break;
            case $iNslS.Events.CLICK:
            case $iNslS.Events.FOCUS:
                document.dispatchEvent(new CustomEvent("sandboxClick"));
                break;
            case $iNslS.Events.CLIPBOARD_WRITE:
                navigator.clipboard.writeText(value.msg).catch(()=>this.metrics.error(`Sandbox: handlePostMessage failed to write to clipboard ${value.msg}, appId: ${appId}`));
                break;
            case $iNslS.Events.COMPONENT_CLOSE:
                context.toggleComponentModal(false);
                break;
            case $iNslS.Events.COMPONENT_OPEN:
                (0, $loe8n.setMetricsApplication)(metricsAppId, app.solutionConfig, undefined, value?.component);
                context.toggleComponentModal(true, value, (data)=>{
                    this.messageService.sendMessage({
                        type: $iNslS.Events.COMPONENT_CLOSE_COMPLETE,
                        value: data
                    }, app);
                    (0, $loe8n.setMetricsApplication)(metricsAppId, app.solutionConfig);
                });
                break;
            case $iNslS.Events.CONSENT_GET:
                this.consentApiHandler(value, app);
                break;
            case $iNslS.Events.CONSENT_UPDATE:
                context.updateConsent(value);
                (0, $7CZdW.onConsent)(value, this.metrics);
                break;
            case $iNslS.Events.CUSTOM_HERO_CLICK:
                context.setConfigStates({
                    customHeroClick: ()=>sendMessage({
                            type: $iNslS.Events.HERO_CLICK
                        })
                });
                break;
            case $iNslS.Events.CUSTOM_LEFT_NAV_CLICK:
                context.setConfigStates({
                    customLeftNavClick: (isOpen)=>sendMessage({
                            type: $iNslS.Events.CUSTOM_LEFT_NAV_CLICK,
                            value: isOpen
                        }),
                    leftNavCloseOnSelection: value
                });
                break;
            case $iNslS.Events.DATA_PREFETCH:
                this.dataPrefetchHandler(value, app);
                break;
            case $iNslS.Events.DATA_REQUEST:
                this.sendDataResponse(value, app, lastConfiguration);
                break;
            case $iNslS.Events.DEPRECATION_WARNING:
                this.sendDeprecationWarning(value, app);
                break;
            case $iNslS.Events.EXC_PULSE:
                this.pulseHandler(value, app);
                break;
            case $iNslS.Events.EXC_SETTINGS:
                this.settingsHandler(value, app);
                break;
            case $iNslS.Events.FEATURE_FLAGS:
                this.featureFlagsHandler(value, app);
                break;
            case $iNslS.Events.FEEDBACK_CONFIG:
                context.enableFeedback(value);
                break;
            case $iNslS.Events.FULFILLABLE_ITEMS:
                {
                    const { fulfillableItems: fulfillableItems, imsOrg: imsOrg } = context;
                    this.fulfillEvent(value, fulfillableItems?.[imsOrg]?.[value.data] || [], app, false);
                    break;
                }
            case $iNslS.Events.GAINSIGHT_INIT:
                (0, $3Zpnv.waitForGainsightInit)().then(()=>this.messageService.sendMessage({
                        type: $iNslS.Events.GAINSIGHT_INIT
                    }, app)).catch(()=>{
                    this.metrics.event("Sandbox.noGainsightInit", {
                        level: $hCZmk.Level.ERROR
                    });
                    this.messageService.sendMessage({
                        type: $iNslS.Events.GAINSIGHT_INIT,
                        value: {
                            error: "Gainsight did not initialize",
                            rejected: true
                        }
                    }, app);
                });
                break;
            case $iNslS.Events.GENERATE_SUBORG:
                {
                    const { overrides: overrides, productContext: productContext } = value.data;
                    let subOrg;
                    try {
                        subOrg = context.getSubOrgFromProductContext({
                            ...productContext,
                            ...overrides || {}
                        });
                    } catch (err) {
                        this.metrics.error("Could not generate sub-org", {
                            error: (0, $iNslS.getErrorMessage)(err),
                            overrides: overrides,
                            productContext: productContext
                        });
                    }
                    this.fulfillEvent(value, subOrg, app, false, "unable to generate sub-org");
                    break;
                }
            case $iNslS.Events.EXTENDED_SHELL_INFO:
                context.getShellConfigurationExtended().then((shellResponse)=>this.fulfillEvent(value, shellResponse, app, false, "unable to generate shellInfoExtended"));
                break;
            case $iNslS.Events.HISTORY:
                this.historyHandler(value, app);
                break;
            case $iNslS.Events.IFRAME_RELOAD:
                {
                    const { cacheBust: cacheBust } = value;
                    app.onFrameReload(cacheBust);
                    break;
                }
            case $iNslS.Events.JIRA_SUBMIT:
                this.jiraFeedbackHandler(value, app);
                break;
            case $iNslS.Events.KEYPRESS:
                $0d9307c0a9dea52c$var$_EventObserver.default.handleIframeKeyPress(value);
                break;
            case $iNslS.Events.LOST_AUTH:
                (0, $lRoWp.queueMetrics)("API Processing lost auth", {
                    data: {
                        event: "LOST_AUTH",
                        value: value
                    }
                }); // Validate the token, because it's probably expired
                this.metrics.event("Sandbox.lostAuth", {
                    level: $hCZmk.Level.ERROR
                }, {
                    appId: metricsAppId,
                    url: value
                });
                context.on401();
                break;
            case $iNslS.Events.MODULES_DATA:
                this.modulesApiHandler(value, app);
                break;
            case $iNslS.Events.NOT_FOUND:
                app.onNotFound();
                break;
            case $iNslS.Events.OPEN_HELP_CENTER:
                document.dispatchEvent(new CustomEvent("openHelpCenter", {
                    detail: value
                }));
                break;
            case $iNslS.Events.PERMISSIONS:
                this.permissionsHandler(value, app);
                break;
            case $iNslS.Events.PRINT_NOW:
                sendMessage({
                    type: $iNslS.Events.PRINT_NOW
                });
                break;
            case $iNslS.Events.RECENT_EVENT:
                context.recentsService.handleRecentsEvent(value, context);
                break;
            case $iNslS.Events.SESSION:
                this.sessionHandler(value, app);
                break;
            case $iNslS.Events.SHELL_SETTINGS:
                this.setProxiedConfiguration(value, app);
                break;
            case $iNslS.Events.SPA_SRC_DOC:
                this.srcDocHandler(value, app);
                break;
            case $iNslS.Events.SKIP_MENU_SET_LIST:
                {
                    const { skipMenuList: skipMenuList } = value;
                    document.dispatchEvent(new CustomEvent("skipMenuList", {
                        detail: skipMenuList || null
                    }));
                    break;
                }
            case $iNslS.Events.TOAST_SUPRESSED:
                this.toastsSupressed.splice(0, 0, [
                    value,
                    Date.now()
                ]);
                $iJaYo.storage.local.set("shellToasts", this.toastsSupressed);
                document.dispatchEvent(new CustomEvent("toastSupressed"));
                break;
            case $iNslS.Events.TRIGGER_NPS:
                document.dispatchEvent(new CustomEvent("triggerNps"));
                break;
        }
    }
    /**
   * Logs iframe usage of deprecated api to EIM.
   * @param key - Deprecated API being used.
   * @param app - AppSandbox object.
   */ /**
   * Rejects an incoming data request event.
   * @param value - Event data
   * @param error - Error description
   * @param app - App Sandbox object
   */ rejectEvent(value, error, app) {
        this.messageService.sendMessage({
            type: $iNslS.Events.DATA_FULFILL,
            value: {
                ...value,
                error: (0, $iNslS.getErrorMessage)(error),
                rejected: true
            }
        }, app);
    }
    /**
   * Fulfills an incoming data event with a provided response. If the response
   * is valid (e.g. not undefined) or it's OK if it's empty, send the message.
   * If it's undefined or not allowed to be empty, send an error message.
   * @param value - Event data
   * @param response - Response data
   * @param app - App Sandbox object
   * @param allowEmpty - If false, empty response will trigger rejection
   * @param errorMessage - Error to show if response is empty.
   */ fulfillEvent(value, response, app, allowEmpty = true, errorMessage = "Unknown error") {
        response !== undefined || allowEmpty ? this.messageService.sendMessage({
            type: $iNslS.Events.DATA_FULFILL,
            value: {
                ...value,
                response: response
            }
        }, app) : this.rejectEvent(value, errorMessage, app);
    }
    /**
   * Handles the case where data has been requested before it is available.
   * Ensures that any remaining requests for data are fulfilled.
   */ processOpenDataRequests(app, lastConfiguration) {
        const { context: context } = app;
        const updatedContext = {
            ...lastConfiguration || {},
            ...context
        };
        Object.values(this.pendindDataRequests).forEach((value)=>value.type in updatedContext && this.sendDataResponse(value, app, lastConfiguration));
    }
    /**
   * Responds to an incoming data message.
   * Queue message for future response if data not yet available.
   * @param value - Data request message
   * @param app - App Sandbox object
   * @param lastConfiguration - Last configuration sent to the iframe
   * @private
   */ async sendDataResponse(value, app, lastConfiguration) {
        const { id: id, type: type } = value;
        if (!lastConfiguration) {
            this.pendindDataRequests[id] = value;
            return;
        }
        const { context: context, customIms: customIms, metricsAppId: metricsAppId } = app;
        const CONTEXT_FETCHED = new Set([
            "sandbox",
            "sandboxes"
        ]);
        this.metrics.event("Sandbox.sendDataResponse", {
            appId: metricsAppId,
            type: type
        });
        let updatedContext = {
            ...lastConfiguration,
            ...context
        }; // Handle customIms explicitly because it is an override on the context and
        // we need to use the new data. If the custom IMS token data is not
        // available, we cannot send the response yet.
        if (customIms) {
            const data = (0, $loe8n.getCustomImsData)(app);
            if (!data) {
                this.pendindDataRequests[id] = value;
                return;
            }
            if (!(0, $loe8n.isValidCustomImsToken)(app)) this.metrics.warn("sendDataResponse had invalid custom token data");
            updatedContext = {
                ...updatedContext,
                ...data
            };
        }
        this.pendindDataRequests[id] && delete this.pendindDataRequests[id];
        let response = updatedContext[type]; // If the user has requested sandbox data wait for the response from
        // the context service.
        if (response === undefined && CONTEXT_FETCHED.has(type)) try {
            const values = await context.contextFetchPromise;
            response = values?.[type];
        } catch (error) {
            return this.rejectEvent(value, error, app);
        }
        this.fulfillEvent(value, response, app, false, `${type} not found`);
    }
    /**
   * Process delayed incoming data messages.
   * @param app App Sandbox object
   */ processEventQueue(app) {
        if (this.queuedDataEvents.length) {
            // Copy and reset the queue before processing.
            const eventsToProcess = this.queuedDataEvents;
            this.queuedDataEvents = [];
            eventsToProcess.forEach((fn)=>fn(app));
        }
    }
    /**
   * Queues incoming event if data is not yet available to fulfill it.
   * @param condition - Condition needed to process right away
   * @param handler - Method to process the event if its delayed (The callee)
   * @param value - Event data
   * @returns true if queued, false otherwise.
   */ queueEvent(condition, handler, value) {
        condition || this.queuedDataEvents.push((app)=>handler(value, app));
        return !condition;
    }
    /**
   * App api handler used to provide application metadata.
   * @param value - Event data, containing application name.
   * @param app - App Sandbox object
   */ /**
   * Updates Unified Shell path with path updates coming from the iframed application.
   * @param value - Application path and title.
   * @param app - App Sandbox object.
   * @private
   */ historyHandler(value, app) {
        let { path: path } = value;
        const { title: title } = value;
        const { basePath: basePath, configURL: configURL, context: context, solutionConfig: solutionConfig } = app;
        const { browserParamFilterList: browserParamFilterList, sandbox: { history: history, pathPrefix: pathPrefix } } = solutionConfig;
        const historyType = (0, $3Zpnv.getHistoryType)(solutionConfig); // If the path prefix of the application exists in the path being
        // provided by the application, remove it before continuing to process
        // the history change.
        // When env is dev:
        // If dev path prefix is an empty string, replace default path prefix as described above.
        // If dev path prefix is a nonempty string, replace dev path prefix as described above.
        const prefix = context.environment === "dev" && pathPrefix?.dev || pathPrefix?.default;
        if (prefix && path.startsWith(prefix)) path = path.replace(prefix, "");
        const { absolutePaths: absolutePaths = false, addParamsToHash: addParamsToHash = false } = typeof history === "object" && history.config || {}; // Hash history modifies the provided path to include the hash as part
        // of the path. For example, if `value.path` is `#something`, the
        // updated value will be `/something`. This keeps the URL tidy.
        if (historyType === $ctGaZ.HISTORY.HASH) {
            const { hash: hash, pathname: pathname, search: search } = new URL(`${window.location.origin}${path}`);
            const pathFromHash = hash ? `/${(0, $jVeiz.hashToPath)({
                hash: hash
            })}` : "";
            path = `${pathname}${pathFromHash}`; // If addParamsToHash solution config property is set, add the search
            // params directly to the hash in the application's frame URL.
            addParamsToHash && (path += search);
        } // Splits the pathname with the pathname in the config to ensure the
        // correct path is preserved on the URL. For example, a pathname of
        // `/dev/sc/page.php` with a config path of `/dev/sc` should net a
        // path of `/page.php` added onto the `basePath`.
        path = absolutePaths ? path : (0, $jVeiz.splitPath)(path, configURL?.pathname || ""); // Only replace double slashes with a single if it's not after a :,
        // denoting that it's part of https://.
        const topPath = `${basePath}${path}`.replace(/([^:])\/{2,}/g, "$1/");
        (0, $2qT0f.updatePath)({
            path: topPath
        }, true, true, context.contextKey, false, browserParamFilterList && new Set(browserParamFilterList));
        title && app.titleService?.update(title);
    }
    /**
   * Sends the global search state (open/closed) to the iframed application.
   * @param app - App Sandbox object
   */ sendCustomSearchValue(app) {
        const { context: { customSearch: { enabled: enabled, open: searchOpenState } } } = app; // Only send event if the state of the search menu has changed
        if (enabled && searchOpenState !== this.searchOpenState) {
            this.messageService.sendMessage({
                type: $iNslS.Events.CUSTOM_SEARCH,
                value: searchOpenState
            }, app);
            this.searchOpenState = searchOpenState;
        }
    }
}
module.exports.APIProcessingService = $0d9307c0a9dea52c$var$APIProcessingService;

});
parcelRegister("ljK83", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hCG2Z = parcelRequire("hCG2Z");

var $d0l2i = parcelRequire("d0l2i");

var $e1c13298bb56e465$var$_metrics = $e1c13298bb56e465$var$_interopRequireWildcard((parcelRequire("17AVh")));
function $e1c13298bb56e465$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $e1c13298bb56e465$var$_getRequireWildcardCache = function() {
        return cache;
    };
    return cache;
}
function $e1c13298bb56e465$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $e1c13298bb56e465$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $e1c13298bb56e465$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
class $e1c13298bb56e465$var$AppHtmlService {
    constructor(cdn){
        $e1c13298bb56e465$var$_defineProperty(this, "cache", {});
        $e1c13298bb56e465$var$_defineProperty(this, "cdn", void 0);
        $e1c13298bb56e465$var$_defineProperty(this, "fallbackDomains", void 0);
        $e1c13298bb56e465$var$_defineProperty(this, "metrics", $e1c13298bb56e465$var$_metrics.default.create("exc.core.AppHtmlService"));
        this.cdn = cdn;
        this.fallbackDomains = [
            window.origin
        ];
    }
    /**
   * Injects additional code to the HTML head to allow the SPA to run in about:srcdoc.
   * @param html - Fetched SPA HTML
   * @param options - HTML request information
   * @private
   */ injectAdditionalCode(html, options) {
        const w = window;
        const runtimeScript = document.getElementById("runtimeScript");
        const { appId: appId, hash: hash = "", nonce: nonce = runtimeScript?.nonce, omegaNonce: omegaNonce = options.nonce || w.digitalData?.nonce || "" } = options;
        let htmlOut = html;
        const postHead = $d0l2i.HEAD_SCRIPT.replace("__APPID__", `"${appId}"`).replace("__HASH__", `"${hash}"`).replace("__NONCE__", `"${omegaNonce}"`);
        if (htmlOut.includes('Needs to be within an iframe!");') && !htmlOut.includes(`["exc-module-runtime"]?.Runtime`)) // Override runtime loader script.
        // This can be removed later when all apps on Thunderbird use the latest loader.
        htmlOut = htmlOut.replace('Needs to be within an iframe!");', 'Needs to be within an iframe!");if(window["exc-module-runtime"] && window["exc-module-runtime"].Runtime)return;');
        htmlOut = htmlOut.replace("<HEAD>", "<head>").replace("</HEAD>", "</head>").replace(/(<head><script>[ \n]*window\._srp.*?<\/script>|<head>)/s, `$1${postHead}`);
        if (nonce) {
            const nonceAttr = `nonce="${nonce}"`;
            htmlOut = htmlOut.replace(/<(script|link)([^>]*)>/g, `<$1$2 ${nonceAttr}>`);
        }
        return htmlOut;
    }
    /**
   * Fetch SPA HTML from the network / service worker.
   * @param url - HTML url
   * @param name - URL name (For logging purposes)
   * @returns HTML
   * @private
   */ async fetchHtmlHelper(url, name) {
        let html = "";
        try {
            // Download html.
            const response = await fetch(url);
            html = await response.text();
        } catch (error) {
            this.metrics.event(`AppHtmlService.${name}.Failure`, {
                url: url
            }, {
                level: $e1c13298bb56e465$var$_metrics.Level.ERROR
            });
        }
        return html;
    }
    /**
   * Fetch SPA HTML from the network / service worker.
   * @param path - Path to SPA HTML
   * @returns HTML
   * @private
   */ async fetchHtml(path) {
        const url = `${this.cdn}/${path}`;
        let html = await this.fetchHtmlHelper(url, "CDN");
        if (!html) {
            // Try fallback domains.
            let fallBackIndex = 1;
            for (const domain of this.fallbackDomains){
                html = await this.fetchHtmlHelper(`${domain}/${path}`, `Fallback${fallBackIndex}`);
                if (html) break;
                fallBackIndex++;
            }
        }
        return html;
    }
    /**
   * Returns SPA HTML from cache or network
   * @param options - HTML request information
   * @returns HTML
   */ async getHtml(options) {
        const queryParams = (0, $hCG2Z.getQueryParams)();
        const { hostname: hostname } = location;
        const { htmlPath: htmlPath = "index.html", liveVersion: liveVersion, spaName: spaName, version: version = queryParams[`${spaName}_version`] || liveVersion } = options;
        const path = `solutions/${spaName}/spa-html-preload/${htmlPath}?${spaName}_version=${version}&shell_domain=${hostname}`;
        if (!this.cache[path]) this.cache[path] = await this.fetchHtml(path);
        return this.cache[path] ? this.injectAdditionalCode(this.cache[path], options) : "";
    }
}
module.exports.default = $e1c13298bb56e465$var$AppHtmlService;

});
parcelRegister("d0l2i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HEAD_SCRIPT = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // eslint-disable-next-line max-len
const $8b9e137388f4915d$var$HEAD_SCRIPT = `<script>!function(t,a,e,i){const{history:o,location:s,parent:n}=t,c="about:srcdoc";if(e&&(t.digitalData=t.digitalData||{},t.digitalData.nonce=e),n["exc-module-runtime"]&&n["exc-module-runtime"].bootstrapRuntime){const a=(a,e)=>t.parent.postMessage(a,e);n["exc-module-runtime"].bootstrapRuntime(t,a,i)}const r=t=>{var a="_"+t;o[a]=o[t],o[t]=(t,e,i)=>{if(i){const[n,r]=(t=>t.startsWith("#")?[t,c+t]:t.startsWith(c+"#")?[t.replace(c,""),t]:[])(i);if(n)try{o[a](t,e,r)}catch{s.hash=n}}}};r("replaceState"),r("pushState"),a&&!s.hash&&(s.hash=a)}(window,__HASH__,__NONCE__,__APPID__);</script>`;
module.exports.HEAD_SCRIPT = $8b9e137388f4915d$var$HEAD_SCRIPT;

});


parcelRegister("36K1U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getBlockNavigation = module.exports.BlockNavigationService = void 0;

var $bzq4v = parcelRequire("bzq4v");

var $3Zpnv = parcelRequire("3Zpnv");

var $iNslS = parcelRequire("iNslS");
function $31d1a7892d50c8ef$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
class $31d1a7892d50c8ef$var$BlockNavigationService {
    constructor(unloadPromptMessage){
        $31d1a7892d50c8ef$var$_defineProperty(this, "unblock", void 0);
        $31d1a7892d50c8ef$var$_defineProperty(this, "unloadPromptMessage", void 0);
        $31d1a7892d50c8ef$var$_defineProperty(this, "correctHash", void 0);
        $31d1a7892d50c8ef$var$_defineProperty(this, "postCallback", void 0);
        $31d1a7892d50c8ef$var$_defineProperty(this, "hasMovedBack", false);
        $31d1a7892d50c8ef$var$_defineProperty(this, "unloadListener", (e)=>{
            e.preventDefault();
            e.returnValue = this.unloadPromptMessage;
        });
        $31d1a7892d50c8ef$var$_defineProperty(this, "hashChangeListener", (e, options)=>{
            // If navigation is cancelled, the hash is updated again back to the original URL, and this
            // listener is called again. To prevent a loop, the "correct" hash (the hash of the page blocking
            // was activated on) is saved. If the new URL has the same hash, allow the change to go through
            // without blocking. Or, if blocking is only on org change and there has not been an org change,
            // it should not be blocked. Update the hasMovedBack flag to prepare for the next location change.
            if (this.correctHash === window.location.hash || options?.onOrgChangeOnly && !(0, $3Zpnv.isOrgOrSubOrgChange)(new URL(e.oldURL).hash, new URL(e.newURL).hash)) {
                this.hasMovedBack = false;
                return;
            }
            e.preventDefault();
            this.postCallback = (navigate)=>{
                const win = window; // The user chose not to navigate, so the hash needs to be updated to return to the previous page
                if (!navigate) {
                    // The navigation object contains all the pages in the browser's navigation history. If the current entry
                    // is not the last entry in the list (found by comparing the current entry's index to the number of entries)
                    // then the navigation was backward in history, and we need to go forward to return to the correct page.
                    // The Navigation API is experimental and cannot be used on all browsers
                    // (https://developer.mozilla.org/en-US/docs/Web/API/Navigation_API)
                    if (win.navigation) {
                        // Do not set hasMovedBack if win.navigation exists
                        if (win.navigation.entries().length !== win.navigation.currentEntry.index + 1) $bzq4v.history.goForward();
                        else $bzq4v.history.goBack();
                    } else {
                        // Hash history has been called once for this change
                        this.hasMovedBack = true;
                        $bzq4v.history.goBack();
                    }
                } else this.blockNavigation(false);
                this.postCallback = $iNslS.NOOP;
            };
        });
        $31d1a7892d50c8ef$var$_defineProperty(this, "hashChangeHandler", $iNslS.NOOP);
        this.unloadPromptMessage = unloadPromptMessage ?? "";
        this.correctHash = "";
        this.postCallback = $iNslS.NOOP;
    }
    /**
   * Called by the HistoryBlockerDialog after navigation has been continued or cancelled
   * @param navigate - True to continue navigation, false to cancel
   * @param callback - Callback from history to continue or cancel navigation
   */ navigate(navigate, callback) {
        callback(navigate);
        this.postCallback?.(navigate);
    }
    /**
   * Handler for before unload event
   * @param e - Before Unload event
   */ /**
   * Block/Unblock navigation
   * @param enabled - True to block, false to unblock
   * @param options - Additional options
   */ blockNavigation(enabled, options) {
        if (!enabled) {
            window.removeEventListener("beforeunload", this.unloadListener);
            window.removeEventListener("hashchange", this.hashChangeHandler);
            this.postCallback = $iNslS.NOOP;
            this.hashChangeHandler = $iNslS.NOOP;
            this.unblock && this.unblock();
            this.correctHash = "";
            this.unloadPromptMessage = "";
            return;
        }
        this.correctHash = `#${$bzq4v.history.location.pathname}`;
        this.unblock = $bzq4v.history.block((location, action)=>{
            if (action !== "REPLACE") {
                const promptUser = options?.onOrgChangeOnly ? (0, $3Zpnv.isOrgOrSubOrgChange)($bzq4v.history.location.pathname, location.pathname) : true;
                if (promptUser) {
                    this.postCallback = (navigate)=>{
                        if (navigate) this.correctHash = `#${$bzq4v.history.location.pathname}`;
                        this.postCallback = $iNslS.NOOP;
                    }; // Hash history treats all location changes as hash changes, so there is no way to tell apart a regular
                    // navigation from a back button click. When the back button is used, it is treated the same as any other hash
                    // change and history.goBack() is called. For a normal hash change, the new hash (location.pathname) would be
                    // the same as the current location in history (the page we are trying to stay on). For a back button change,
                    // the new hash would be that of the page two back in history. Therefore, if history.goBack() has been called for
                    // a hash change and the new hash is not the same as the current page hash, we have moved back two entries in history
                    // and need to move forward again to return to the correct page.
                    if (`#${location.pathname}` === this.correctHash) return;
                    else if (this.hasMovedBack && location.pathname !== $bzq4v.history.location.pathname) {
                        $bzq4v.history.go(2);
                        this.hasMovedBack = false;
                    } else return this.unloadPromptMessage;
                }
            }
        });
        window.addEventListener("beforeunload", this.unloadListener);
        this.hashChangeHandler = (e)=>this.hashChangeListener(e, options);
        window.addEventListener("hashchange", this.hashChangeHandler);
    }
}
module.exports.BlockNavigationService = $31d1a7892d50c8ef$var$BlockNavigationService;
let $31d1a7892d50c8ef$var$blockNavigation;
/**
 * Returns an instance of the Block Navigation service.
 */ const $31d1a7892d50c8ef$var$getBlockNavigation = (unloadPromptMessage)=>{
    if (!$31d1a7892d50c8ef$var$blockNavigation) $31d1a7892d50c8ef$var$blockNavigation = new $31d1a7892d50c8ef$var$BlockNavigationService(unloadPromptMessage);
    return $31d1a7892d50c8ef$var$blockNavigation;
};
module.exports.getBlockNavigation = $31d1a7892d50c8ef$var$getBlockNavigation;

});

parcelRegister("fnuc3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.updateWorkspaceURL = module.exports.cleanSidenavUrls = void 0;

var $jVeiz = parcelRequire("jVeiz");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ /**
 * Determines which base to use for the path based on whether the
 * `base` property is defined in the route config. This will be the default
 * instead of `this.basePath` unless it's not defined. This is for cases when
 * multiple configs are needed but need a single base. For example, Target has
 * 5 route configs (`/target/audiences`, etc) but really only want `/target`
 * to be the base.
 * @returns The base path to use.
 */ const $7ef69b34e5ae75fe$var$getBase = ({ basePath: basePath, solutionConfig: { base: base } })=>base ? (0, $jVeiz.getUpdatedPath)(basePath, base) : basePath;
const $7ef69b34e5ae75fe$var$cleanUrl = (url, app)=>{
    if (!url) return "";
    return /^https?:/.test(url) ? url : (0, $jVeiz.getPathWithoutTenant)(`${$7ef69b34e5ae75fe$var$getBase(app)}${url}`);
};
const $7ef69b34e5ae75fe$var$cleanSidenavUrls = (menu, app)=>{
    for (const item of menu){
        if ("url" in item && item.url) item.url = item.absolutePath ? item.url : $7ef69b34e5ae75fe$var$cleanUrl(item.url, app);
        else if ("children" in item && item.children) // nested children items
        $7ef69b34e5ae75fe$var$cleanSidenavUrls(item.children, app);
        else if ("items" in item) // items nested in headers
        $7ef69b34e5ae75fe$var$cleanSidenavUrls(item.items, app);
        else if ("selectOn" in item) item.selectOn = item.selectOn.map((path)=>$7ef69b34e5ae75fe$var$cleanUrl(path, app)); // item selector paths
    }
};
module.exports.cleanSidenavUrls = $7ef69b34e5ae75fe$var$cleanSidenavUrls;
const $7ef69b34e5ae75fe$var$generateUid = (name, parentUid)=>parentUid ? `${parentUid}_${name}` : name;
/**
 * Updates the workspaces URLs.
 * @param workspace - Workspace Object
 * @param app - App Sandbox object.
 * @param parent Internal - Workspace parent object (This method is used recursively)
 */ const $7ef69b34e5ae75fe$var$updateWorkspaceURL = (workspace, app, parent)=>{
    if (!workspace.menu) {
        workspace.uid = $7ef69b34e5ae75fe$var$generateUid(workspace.name, (parent || {}).uid);
        workspace.url = $7ef69b34e5ae75fe$var$cleanUrl(workspace.url, app);
        return;
    }
    workspace.uid = $7ef69b34e5ae75fe$var$generateUid(workspace.name, (parent || {}).uid); // Ensure that the workspace url is set to at least an empty string. Not
    // setting the url tells us that the workspace should not be added to the
    // workspace menu as the first item.
    workspace.url = $7ef69b34e5ae75fe$var$cleanUrl(workspace.url, app);
    workspace.menu.forEach((ws)=>{
        ws.uid = $7ef69b34e5ae75fe$var$generateUid(ws.name, workspace.uid);
        ws.url = $7ef69b34e5ae75fe$var$cleanUrl(ws.url, app);
        ws.menu && $7ef69b34e5ae75fe$var$updateWorkspaceURL(ws, app, workspace);
    }); // Clicking on the top-level workspace opens the menu. If the workspace url
    // is set, we add it as the first item in the menu so that it can be
    // navigated to.
    workspace.url && workspace.menu.unshift({
        name: workspace.name,
        uid: $7ef69b34e5ae75fe$var$generateUid(workspace.name, workspace.uid),
        url: workspace.url
    });
};
module.exports.updateWorkspaceURL = $7ef69b34e5ae75fe$var$updateWorkspaceURL;

});

parcelRegister("fkM9n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $iNslS = parcelRequire("iNslS");

var $f387c4b7d251a380$var$_emitter = $f387c4b7d251a380$var$_interopRequireDefault((parcelRequire("dJSrf")));

var $9OLey = parcelRequire("9OLey");

var $ahF0u = parcelRequire("ahF0u");
function $f387c4b7d251a380$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f387c4b7d251a380$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
const $f387c4b7d251a380$var$ACTIVITY_EVENTS = [
    "active",
    "iframeActive",
    "keyboard"
];
/**
 * Class that listens to all events on the Shell.
 */ class $f387c4b7d251a380$var$EventObserver extends $f387c4b7d251a380$var$_emitter.default {
    // don't emit event when user is typing
    /**
   * Initialise EventObservers and related observers.
   */ constructor(){
        super();
        $f387c4b7d251a380$var$_defineProperty(this, "deniedTags", [
            "INPUT",
            "TEXTAREA"
        ]);
        $f387c4b7d251a380$var$_defineProperty(this, "modifiers", [
            "altKey",
            "ctrlKey",
            "metaKey",
            "shiftKey"
        ]);
        $f387c4b7d251a380$var$_defineProperty(this, "allowedClasses", [
            ".spectrum-Shell-feedback-button"
        ]);
        $f387c4b7d251a380$var$_defineProperty(this, "emitActivity", void 0);
        $f387c4b7d251a380$var$_defineProperty(this, "registeredCombos", void 0);
        $f387c4b7d251a380$var$_defineProperty(this, "preventDefaultCombos", void 0);
        $f387c4b7d251a380$var$_defineProperty(this, "registerKeyHandler", (combo, callback)=>{
            if (!combo || !callback) return;
            const id = (0, $ahF0u.v4)();
            this.registeredCombos.push({
                callback: callback,
                combo: combo,
                id: id
            });
            return id;
        });
        $f387c4b7d251a380$var$_defineProperty(this, "isDeniedTag", (element)=>this.deniedTags.includes(element.tagName));
        $f387c4b7d251a380$var$_defineProperty(this, "containsClass", (classes, element)=>classes.find((className)=>element.closest(className)));
        $f387c4b7d251a380$var$_defineProperty(this, "handleClick", (e)=>{
            this.emitActivity();
            const targetElement = e.target;
            if (!targetElement) return;
            const allowedClass = this.containsClass(this.allowedClasses, targetElement);
            const isTrackingRequired = !!allowedClass || !this.isDeniedTag(targetElement);
            if (!e || !isTrackingRequired) return;
            const { className: className, textContent: textContent } = targetElement; // Don't send through events that are not useful (possible case, SVG clicks)
            if ((!className || typeof className !== "string") && !textContent && !e.data) return;
            this.emit(e.type, {
                data: {
                    className: className,
                    textContent: textContent,
                    ...e.data || {}
                },
                target: e.target,
                type: e.type
            });
        });
        $f387c4b7d251a380$var$_defineProperty(this, "comboMatches", (e, combo)=>e.key === combo.key && this.modifiers.every((key)=>!(key in combo) || combo[key] === e[key]));
        $f387c4b7d251a380$var$_defineProperty(this, "handleIframeActive", ()=>this.emit("iframeActive"));
        $f387c4b7d251a380$var$_defineProperty(this, "handleIframeKeyPress", (e)=>{
            const element = document.activeElement;
            element && this.isDeniedTag(element) || this.registeredCombos.some(({ callback: callback, combo: combo })=>this.comboMatches(e, combo) && callback());
        });
        $f387c4b7d251a380$var$_defineProperty(this, "handleKeyPress", (e)=>{
            const element = document.activeElement;
            if (this.modifiers.some((key)=>e[key])) this.checkAgainstCombos(e);
             // Handle shortcuts when focus is in the shell
            this.handleIframeKeyPress(e);
            if (element && this.isDeniedTag(element)) {
                this.emitActivity();
                return;
            }
            this.emit("keyboard", {
                altKey: e.altKey,
                bubbles: e.bubbles,
                ctrlKey: e.ctrlKey,
                isComposing: e.isComposing,
                key: e.key,
                keyCode: e.keyCode,
                location: e.location,
                metaKey: e.metaKey,
                repeat: e.repeat,
                shiftKey: e.shiftKey,
                target: e.target,
                type: e.type
            });
        });
        $f387c4b7d251a380$var$_defineProperty(this, "checkAgainstCombos", (e)=>{
            for (const combo of this.preventDefaultCombos)if (this.comboMatches(e, combo)) {
                e.preventDefault();
                return;
            }
        });
        $f387c4b7d251a380$var$_defineProperty(this, "setPreventDefaultCombos", (arr)=>{
            this.preventDefaultCombos = arr;
        });
        $f387c4b7d251a380$var$_defineProperty(this, "watch", ()=>{
            window.addEventListener("keydown", this.handleKeyPress);
            window.addEventListener("click", this.handleClick);
            window.addEventListener("mouseup", this.handleClick);
            window.addEventListener("mousemove", ()=>this.emitActivity());
            window.addEventListener("focus", ()=>this.emitActivity());
            window.addEventListener("scroll", ()=>this.emitActivity());
        });
        this.preventDefaultCombos = [];
        this.registeredCombos = [];
        this.emitActivity = (0, $iNslS.throttleQueue)(()=>this.emit("active"), 1000, true);
        this.watch();
        $9OLey.Internal.registerActivityEmitter(this);
    }
    get activityEvents() {
        return $f387c4b7d251a380$var$ACTIVITY_EVENTS;
    }
    /**
   * Registers a keypress handler for a unified shell component.
   * @param combo Keyboard combination.
   * @param {Function} callback Callback to be executed on combination.
   */ unregisterKeyHandler(idToRemove) {
        const idx = this.registeredCombos.findIndex(({ id: id })=>id === idToRemove);
        this.registeredCombos.splice(idx, 1);
    }
}
var $f387c4b7d251a380$var$_default = new $f387c4b7d251a380$var$EventObserver();
module.exports.default = $f387c4b7d251a380$var$_default;

});
parcelRegister("ahF0u", function(module, exports) {

var $3nWHT = parcelRequire("3nWHT");

var $iCk7b = parcelRequire("iCk7b");
var $77cb4d02fba11e54$var$uuid = $iCk7b;
$77cb4d02fba11e54$var$uuid.v1 = $3nWHT;
$77cb4d02fba11e54$var$uuid.v4 = $iCk7b;
module.exports = $77cb4d02fba11e54$var$uuid;

});
parcelRegister("3nWHT", function(module, exports) {

var $kAKZs = parcelRequire("kAKZs");

var $8L0YP = parcelRequire("8L0YP");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $27710f09d9c054ec$var$_nodeId;
var $27710f09d9c054ec$var$_clockseq;
// Previous uuid creation time
var $27710f09d9c054ec$var$_lastMSecs = 0;
var $27710f09d9c054ec$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $27710f09d9c054ec$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $27710f09d9c054ec$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $27710f09d9c054ec$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $kAKZs();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $27710f09d9c054ec$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $27710f09d9c054ec$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $27710f09d9c054ec$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $27710f09d9c054ec$var$_lastMSecs + (nsecs - $27710f09d9c054ec$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $27710f09d9c054ec$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    $27710f09d9c054ec$var$_lastMSecs = msecs;
    $27710f09d9c054ec$var$_lastNSecs = nsecs;
    $27710f09d9c054ec$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $8L0YP(b);
}
module.exports = $27710f09d9c054ec$var$v1;

});
parcelRegister("kAKZs", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $efdb9eb6b34e64ab$var$getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if ($efdb9eb6b34e64ab$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $efdb9eb6b34e64ab$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $efdb9eb6b34e64ab$var$getRandomValues($efdb9eb6b34e64ab$var$rnds8);
        return $efdb9eb6b34e64ab$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $efdb9eb6b34e64ab$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $efdb9eb6b34e64ab$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $efdb9eb6b34e64ab$var$rnds;
    };
}

});

parcelRegister("8L0YP", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $6603792b52b40716$var$byteToHex = [];
for(var $6603792b52b40716$var$i = 0; $6603792b52b40716$var$i < 256; ++$6603792b52b40716$var$i)$6603792b52b40716$var$byteToHex[$6603792b52b40716$var$i] = ($6603792b52b40716$var$i + 0x100).toString(16).substr(1);
function $6603792b52b40716$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $6603792b52b40716$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
module.exports = $6603792b52b40716$var$bytesToUuid;

});


parcelRegister("iCk7b", function(module, exports) {

var $kAKZs = parcelRequire("kAKZs");

var $8L0YP = parcelRequire("8L0YP");
function $d8db60fd50ca059e$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $kAKZs)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $8L0YP(rnds);
}
module.exports = $d8db60fd50ca059e$var$v4;

});



parcelRegister("WQJPg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.PermissionService = module.exports.getKey = void 0;

var $afnQ2 = parcelRequire("afnQ2");

var $756c1f695958d1ec$var$_metrics = $756c1f695958d1ec$var$_interopRequireDefault((parcelRequire("17AVh")));
function $756c1f695958d1ec$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $756c1f695958d1ec$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/**
 * Map of key property to high level permission prefix.
 */ const $756c1f695958d1ec$var$KEY_MAP = {
    permissions: "permissions",
    resourceTypes: "resource-types"
};
/**
 * Generate the org/sandbox key that will be used to manage the data.
 * @param orgId Org portion of the key.
 * @param name Sandbox name.
 * @param type Sandbox type.
 * @returns Unique key for storing permissions.
 */ const $756c1f695958d1ec$var$getKey = (orgId, { name: name, type: type })=>`${orgId}||${type}:${name}`;
/**
 * Permission service.
 */ module.exports.getKey = $756c1f695958d1ec$var$getKey;
class $756c1f695958d1ec$var$PermissionService {
    constructor(){
        $756c1f695958d1ec$var$_defineProperty(this, "metrics", $756c1f695958d1ec$var$_metrics.default.create("exc.PermissionService"));
        $756c1f695958d1ec$var$_defineProperty(this, "fetched", new Set());
        $756c1f695958d1ec$var$_defineProperty(this, "maxKeys", 10);
        $756c1f695958d1ec$var$_defineProperty(this, "permissionKeys", []);
        $756c1f695958d1ec$var$_defineProperty(this, "permissions", {});
        $756c1f695958d1ec$var$_defineProperty(this, "promises", {});
    }
    /**
   * Builds the permission payload that will be sent to the resolved promise.
   * @param requestedPermissions Object containing lists of permissions
   *   and resource types to build the payload from.
   * @param key The current org/sandbox key for permissions.
   * @returns Permissions Response
   */ buildPayload(requestedPermissions, key) {
        const res = {};
        const storedPermissions = (this.permissions || {})[key];
        storedPermissions && Object.keys(requestedPermissions).forEach((type)=>{
            (requestedPermissions[type] || []).forEach((reqPerm)=>{
                if (reqPerm === "*") Object.entries(storedPermissions).forEach(([storedKey, storedVal])=>{
                    const permType = `/${$756c1f695958d1ec$var$KEY_MAP[type]}/`;
                    if (storedKey.startsWith(permType)) {
                        reqPerm = storedKey.replace(permType, "");
                        res[type] = res[type] || {};
                        res[type][reqPerm] = storedVal;
                    }
                });
                const permKey = `/${$756c1f695958d1ec$var$KEY_MAP[type]}/${reqPerm}`;
                if (storedPermissions[permKey]) {
                    res[type] = res[type] || {};
                    res[type][reqPerm] = storedPermissions[permKey];
                }
            });
        });
        return res;
    }
    /**
   * Attempt to complete unresolved promises that are waiting for certain
   * permissions to be available.
   * @param key The current org/sandbox key for permissions.
   */ completePromises(key) {
        if (!(key in this.promises)) return;
        Object.values(this.promises[key]).forEach(({ permissions: permissions, resolve: resolve })=>resolve(this.buildPayload(permissions, key)));
        delete this.promises[key];
    }
    /**
   * Ensures that the list of cached permissions remains at `maxKeys` length.
   * Removes the key from the list if it exists and adds it back to the top of
   * the list to show that it's been used most frequently. It also removes the
   * oldest key from the list if the list has grown too large.
   * @param key Org ID / sandbox key.
   */ ensureCacheSize(key) {
        // Remove the current key, as it'll be added back to the top later.
        const keyIdx = this.permissionKeys.indexOf(key);
        keyIdx > -1 && this.permissionKeys.splice(keyIdx, 1); // Ensure that the list of permissions doesn't get too large.
        this.permissionKeys.splice(0, 0, key);
        if (this.permissionKeys.length > this.maxKeys) {
            const removedKey = this.permissionKeys.pop();
            delete this.permissions[removedKey];
        }
    }
    /**
   * Fetches user permissions from PALM via GQL.
   * @async
   * @param orgId Current Org ID.
   * @param sandbox PALM Sandbox.
   */ async fetch(orgId, sandbox) {
        const key = $756c1f695958d1ec$var$getKey(orgId, sandbox);
        try {
            const res = await (0, $afnQ2.getUserPermissions)();
            const policies = res.effectivePolicies.policies;
            const permissions = {};
            policies.forEach(({ name: name, privileges: privileges })=>permissions[name] = privileges);
            this.set(orgId, sandbox, permissions);
            this.fetched.add(key);
        } catch (e) {
            this.metrics.error(`Failed to fetch user permissions: ${e}`, {
                orgId: orgId,
                sandbox: sandbox
            });
            this.rejectPromises(key);
        }
    }
    /**
   * Gets a permissions object containing requested permissions. This is either
   * a resolved promise if the data exists or a promise that will be resolved
   * once the permissions are available.
   * @param permissions Object containing permissions and resourceTypes
   *   to get for the current key.
   * @param orgId Current Org ID.
   * @param sandbox PALM Sandbox.
   * @returns Permissions Response
   */ get(permissions, orgId, sandbox) {
        const key = $756c1f695958d1ec$var$getKey(orgId, sandbox); // If there is an existing promise for the requested key, return the promise.
        if (key in this.promises) return this.getPromise(permissions, key);
         // If the data hasn't been fetched this session yet, fetch it. Always gets
        // data once per session to ensure the user has up-to-date data every couple
        // of refreshes so a log-out isn't required.
        this.fetched.has(key) || this.fetch(orgId, sandbox); // If the key exists in permissions, there is data, so resolve the promise
        // with that data. If not, return the promise for the data.
        return key in this.permissions ? Promise.resolve(this.buildPayload(permissions, key)) : this.getPromise(permissions, key);
    }
    /**
   * Creates a promise and adds it to the list of unresolved promises.
   * @param permissions Permissions/resourceTypes needed to resolve the
   *   new promise.
   * @param key The current org/sandbox key for permissions.
   * @returns Permissions Promise
   */ getPromise(permissions, key) {
        const jsonString = JSON.stringify(permissions); // Checks if there is a promise for the current permissions requested. If
        // so, return that promise to the caller.
        if (key in this.promises && jsonString in this.promises[key]) return this.promises[key][jsonString].promise;
        const res = {
            permissions: permissions
        };
        res.promise = new Promise((resolve, reject)=>{
            res.resolve = resolve;
            res.reject = reject;
        });
        this.promises[key] = this.promises[key] || {};
        this.promises[key][jsonString] = res;
        return res.promise;
    }
    /**
   * Rejects unresolved promises that are waiting for certain permissions to be
   * available if an error occurs when fetching.
   * @param key The current org/sandbox key for permissions.
   */ rejectPromises(key) {
        if (!(key in this.promises)) return;
        Object.values(this.promises[key]).forEach(({ reject: reject })=>reject());
        delete this.promises[key];
    }
    /**
   * Set the permissions that this service maintains. This will come from GQL.
   * Attempt to complete existing promises with the newly received promises.
   * @param orgId The org to assign to the
   * @param sandbox The current sandbox to use for permissions requests.
   * @param permissions Permissions object to use.
   */ set(orgId, sandbox, permissions) {
        const key = $756c1f695958d1ec$var$getKey(orgId, sandbox);
        this.permissions[key] = permissions; // Ensures the cached set of permissions is up-to-date, has removed the
        // oldest key / permissions, and keeps the list ordered.
        this.ensureCacheSize(key);
        this.completePromises(key);
    }
    /**
   * Sets the context in which this service should operate.
   * @param orgId The current org to use for permissions requests.
   * @param sandbox The current sandbox to use for permissions requests.
   * @param hasAEP Does the org have AEP?
   */ setContext(orgId, sandbox, hasAEP = true) {
        // We don't need to fetch permissions if the user doesn't have PALM
        if (!hasAEP) return;
        const key = $756c1f695958d1ec$var$getKey(orgId, sandbox); // If there are permissions for this key already, don't need to fetch again.
        // Additionally, updates the order of the caching keys to keep the latest
        // key at the top of the list.
        if (key in this.permissions) this.ensureCacheSize(key);
         // Fetch the data once per page load. This ensures the data will always be
        // up-to-date on across page loads.
        this.get({}, orgId, sandbox);
    }
}
module.exports.PermissionService = $756c1f695958d1ec$var$PermissionService;
var $756c1f695958d1ec$var$_default = new $756c1f695958d1ec$var$PermissionService();
module.exports.default = $756c1f695958d1ec$var$_default;

});

parcelRegister("5FoVO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.SANDBOX_TYPES = module.exports.PROVIDERS = void 0;

var $ihFuI = parcelRequire("ihFuI");
/*************************************************************************
 * Copyright 2022 Adobe
 * All Rights Reserved.
 *
 * NOTICE: Adobe permits you to use, modify, and distribute this file in
 * accordance with the terms of the Adobe license agreement accompanying
 * it. If you have received this file from a source other than Adobe,
 * then your use, modification, or distribution of it requires the prior
 * written permission of Adobe.
 **************************************************************************/ /**
 * The Feature Flags API provides feature flag data from LaunchDarkly and Floodgate.
 *
 * To consume this API, add the following import to your code.
 *
 * ```typescript
 * import featureFlags from '@adobe/exc-app/featureflags';
 * ```
 *
 * The default export is an object of type [FeatureFlagsApi](../interfaces/_featureflags_.featureflags.md)
 *
 * API reference: [scroll down](#index)
 *
 * ### Sample code
 *
 * ```typescript
 * import featureFlags from '@adobe/exc-app/featureflags';
 *
 * const featureFlags = await featureFlags.get(['cjm', 'experience-platform']);
 * ```
 *
 * Feature flags can also be requested from Floodgate by:
 * - including the provider in the options
 * - including the clientIds in the options (instead of projectIds)
 * If no provider is specified, the default provider is LaunchDarkly.
 *
 * ```typescript
 * import featureFlags, {PROVIDERS} from '@adobe/exc-app/featureflags';
 *
 * const floodgateFlags = await featureFlags().get({clientIds: ['unified-shell'], provider: PROVIDERS.FLOODGATE});
 * ```
 *
 * All feature flags can be requested using the key '*'
 * ```typescript
 * import featureFlags, {PROVIDERS} from '@adobe/exc-app/featureflags';
 *
 * const featureFlags = await featureFlags.get(['*']);
 *
 * const featureFlags = await featureFlags.get({clientIds: ['*'], provider: PROVIDERS.FLOODGATE});
 *
 * ```
 * In some cases you may want to include context options that are not already
 * included in the current app's active context. For example, requesting feature
 * flags for a project that uses sandboxes from an app that does not.
 *
 * To include options in the request, pass an object with the projectIds or clientIds and the context options.
 *
 * ```typescript
 * import featureFlags from '@adobe/exc-app/featureflags';
 *
 * const sandbox = {name: 'name'};
 * const featureFlags = await featureFlags.get({projectsIds: ['cjm'], sandbox});
 * ```
 *
 * API for fetching app data.
 * @packageDocumentation
 * @module featureflags
 */ let $7290fdfb73ca3b03$var$PROVIDERS;
module.exports.PROVIDERS = $7290fdfb73ca3b03$var$PROVIDERS;
(function(PROVIDERS) {
    PROVIDERS["FLOODGATE"] = "Floodgate";
    PROVIDERS["LAUNCH_DARKLY"] = "Launch Darkly";
})($7290fdfb73ca3b03$var$PROVIDERS || (module.exports.PROVIDERS = $7290fdfb73ca3b03$var$PROVIDERS = {}));
let $7290fdfb73ca3b03$var$SANDBOX_TYPES;
module.exports.SANDBOX_TYPES = $7290fdfb73ca3b03$var$SANDBOX_TYPES;
(function(SANDBOX_TYPES) {
    SANDBOX_TYPES["development"] = "DEVELOPMENT";
    SANDBOX_TYPES["production"] = "PRODUCTION";
})($7290fdfb73ca3b03$var$SANDBOX_TYPES || (module.exports.SANDBOX_TYPES = $7290fdfb73ca3b03$var$SANDBOX_TYPES = {}));
const $7290fdfb73ca3b03$var$featureFlags = {
    get: (params)=>{
        return (0, $ihFuI.getImpl)("featureFlags")().get(params);
    }
};
var $7290fdfb73ca3b03$var$_default = $7290fdfb73ca3b03$var$featureFlags;
module.exports.default = $7290fdfb73ca3b03$var$_default;

});

parcelRegister("7Jeo0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $iJaYo = parcelRequire("iJaYo");

var $65b87c3d4f3a5ac9$var$_stringHash = $65b87c3d4f3a5ac9$var$_interopRequireDefault((parcelRequire("h9eEw")));

var $2sUrb = parcelRequire("2sUrb");
function $65b87c3d4f3a5ac9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ const $65b87c3d4f3a5ac9$var$STORAGE_KEY = "unifiedShellCachedSessions";
const $65b87c3d4f3a5ac9$var$localCache = (0, $iJaYo.getLocalCache)($65b87c3d4f3a5ac9$var$STORAGE_KEY);
class $65b87c3d4f3a5ac9$var$SessionService {
    /**
   * Get session from response when available.
   * @param {DiscoveryResponse} response - Discovery response data
   * @param {DiscoverySource} source - Solution discovery source definition
   * @param {CoreContext} context - Context object
   * @param {DiscoveryOptions} options - Additional discovery options
   * @returns {DiscoveryResponse} Discovery response
   */ async getSessionFromResponse(response, source, context, options) {
        if (response.session && options.sessionConfig && source.includesSession) {
            const { session: id, sessionExpires: expires = 0 } = response; // Got session.
            const session = await this.setSession({
                expires: expires,
                id: id
            }, context, options); // Pass the expires downstream so we don't need to get it from local storage.
            response.sessionExpires = session.expires;
        }
        return response;
    }
    /**
   * Returns a one way hash of the session scope.
   * @param {CoreContext} context - Context object
   * @param {SessionConfig} sessionConfig - Application Session configuration
   * @returns {string} hash
   * @private
   */ getSessionHash(context, sessionConfig) {
        const { scope: scope } = sessionConfig;
        const { userId: userId } = context.imsProfile || {};
        const sessionInfo = {
            userId: userId
        };
        scope === $2sUrb.SessionScope.USER || (sessionInfo.imsOrgId = context.imsOrg);
        scope === $2sUrb.SessionScope.CONTEXT && (sessionInfo.contextId = context.contextId);
        return (0, $65b87c3d4f3a5ac9$var$_stringHash.default)(JSON.stringify(sessionInfo)).toString();
    }
    /**
   * Stores session data in the discovery cache.
   * @param {Session} session - Session object
   * @param {CoreContext} context - Context object
   * @param {DiscoveryOptions} options - Discovery Options
   */ async setSession(session, context, options) {
        const { appId: appId, sessionConfig: sessionConfig } = options;
        if (!sessionConfig) throw new Error("Session config not provided");
        if (!session.expires) {
            if (!sessionConfig.defaultTTL) throw new Error("Session expiry not provided");
            session.expires = Date.now() + sessionConfig.defaultTTL * 1000;
        }
        const hash = this.getSessionHash(context, sessionConfig);
        const key = sessionConfig.multiSessions ? `${appId}/session-${hash}` : `${appId}/session`;
        const cacheSession = {
            hash: hash,
            ...session
        };
        await $65b87c3d4f3a5ac9$var$localCache.set(key, cacheSession);
        return session;
    }
    /**
   * Invalidates cached session (If available and matching)
   * @param {Session} session - Session object
   * @param {CoreContext} context - Context object
   * @param {DiscoveryOptions} options - Discovery Options
   */ async invalidateSession(session, context, options) {
        const { appId: appId, sessionConfig: sessionConfig } = options;
        if (!sessionConfig) throw new Error("Session config not provided");
        const hash = this.getSessionHash(context, sessionConfig);
        const key = sessionConfig.multiSessions ? `${appId}/session-${hash}` : `${appId}/session`;
        const cachedSession = await $65b87c3d4f3a5ac9$var$localCache.get(key); // Only invalidate if IDs match.
        if (cachedSession?.id === session.id) await $65b87c3d4f3a5ac9$var$localCache.remove(key);
    }
    /**
   * Reads session data from discovery cache (If available)
   * @param {CoreContext} context - Context object
   * @param {DiscoveryOptions} options - Discovery Options
   * @param {DiscoverySource} source - Solution discovery source definition
   * @param {DiscoveryService} discoveryService - Discovery Service
   * @returns {Session|undefined} Session object (If available)
   */ async getSession(context, options, source, discoveryService) {
        const { appId: appId, sessionConfig: sessionConfig } = options;
        if (!sessionConfig) return;
        const hash = this.getSessionHash(context, sessionConfig);
        const key = sessionConfig.multiSessions ? `${appId}/session-${hash}` : `${appId}/session`;
        let session = await $65b87c3d4f3a5ac9$var$localCache.get(key);
        if (session && session.hash === hash) {
            // Remove hash before sending back
            session = {
                ...session
            };
            delete session.hash;
            return session;
        }
        if (sessionConfig.getFromDiscovery && source && discoveryService) {
            // Skip cache if running discovery to get a session.
            const sessionOptions = {
                ...options,
                sessionRequest: true
            };
            const { session: id, sessionExpires: expires } = await discoveryService.getSourceFromDiscovery(source, context, sessionOptions);
            if (id && expires) return {
                expires: expires,
                id: id
            };
        }
    }
}
const $65b87c3d4f3a5ac9$var$sessionService = new $65b87c3d4f3a5ac9$var$SessionService();
var $65b87c3d4f3a5ac9$var$_default = $65b87c3d4f3a5ac9$var$sessionService;
module.exports.default = $65b87c3d4f3a5ac9$var$_default;

});
parcelRegister("2sUrb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.SessionScope = void 0;

var $ihFuI = parcelRequire("ihFuI");
/*************************************************************************
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: Adobe permits you to use, modify, and distribute this file in
 * accordance with the terms of the Adobe license agreement accompanying
 * it. If you have received this file from a source other than Adobe,
 * then your use, modification, or distribution of it requires the prior
 * written permission of Adobe.
 **************************************************************************/ /**
 * APIs to get, set or invalidate session data. These APIs are meant for applications using their
 * own session management in addition Adobe IMS. These APIs are not meant to manage session but
 * rather cache and recycle them whenever possible.
 *
 * To consume this API, add the following import to your code.
 *
 * ```typescript
 * import session from '@adobe/exc-app/session';
 * ```
 *
 * The default export is an object of type [SessionApi](../interfaces/_session_.sessionapi.md)
 *
 * API reference: [scroll down](#index)
 *
 * ### Sample code
 *
 * ``` typescript
 * import session from '@adobe/exc-app/settings';
 *
 * // Get
 * const session = await session.get();
 *
 * // Set to expire an hour from now
 * await session.set({
 *   expires: Date.now() + 3600 * 1000,
 *   id: 'SESSION_ID'
 * });
 *
 * // Invalidate session
 * const session = await session.get();
 * await session.invalidate(session);
 * ```
 * @packageDocumentation
 * @module session
 */ /**
 * Sets the scope validity. Ensuring a session can not be used outside of its context.
 */ let $bb0021f888a8444a$var$SessionScope;
/**
 * The session object.
 */ module.exports.SessionScope = $bb0021f888a8444a$var$SessionScope;
(function(SessionScope) {
    SessionScope["USER"] = "user";
    SessionScope["ORG"] = "org";
    SessionScope["CONTEXT"] = "context";
})($bb0021f888a8444a$var$SessionScope || (module.exports.SessionScope = $bb0021f888a8444a$var$SessionScope = {}));
const $bb0021f888a8444a$var$session = {
    get: ()=>(0, $ihFuI.getImpl)("session")().get(),
    invalidate: (session)=>(0, $ihFuI.getImpl)("session")().invalidate(session),
    set: (session)=>(0, $ihFuI.getImpl)("session")().set(session)
};
var $bb0021f888a8444a$var$_default = $bb0021f888a8444a$var$session;
module.exports.default = $bb0021f888a8444a$var$_default;

});


parcelRegister("hFGrB", function(module, exports) {

var $Ha5sG = parcelRequire("Ha5sG");
module.exports = $Ha5sG("bZL4Z").then(()=>parcelRequire("jypch"));

});

parcelRegister("kV60S", function(module, exports) {

var $Ha5sG = parcelRequire("Ha5sG");
module.exports = $Ha5sG("6ztEU").then(()=>parcelRequire("lWz3P"));

});

parcelRegister("gORGm", function(module, exports) {

var $Ha5sG = parcelRequire("Ha5sG");
module.exports = $Ha5sG("9eA6B").then(()=>parcelRequire("laJMr"));

});


parcelRegister("22BGp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.ConnectionMonitorService = module.exports.CONNECTION_UNSTABLE_THRESHOLD = module.exports.CONNECTION_FAILURE_THRESHOLD = void 0;

var $c33e8340ba6e5159$var$_emitter = $c33e8340ba6e5159$var$_interopRequireDefault((parcelRequire("dJSrf")));

var $c33e8340ba6e5159$var$_metrics = $c33e8340ba6e5159$var$_interopRequireWildcard((parcelRequire("17AVh")));
function $c33e8340ba6e5159$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $c33e8340ba6e5159$var$_getRequireWildcardCache = function() {
        return cache;
    };
    return cache;
}
function $c33e8340ba6e5159$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $c33e8340ba6e5159$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $c33e8340ba6e5159$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c33e8340ba6e5159$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
const $c33e8340ba6e5159$var$CONNECTION_FAILURE_THRESHOLD = 4;
module.exports.CONNECTION_FAILURE_THRESHOLD = $c33e8340ba6e5159$var$CONNECTION_FAILURE_THRESHOLD;
const $c33e8340ba6e5159$var$CONNECTION_UNSTABLE_THRESHOLD = 30000; // 30 seconds of instibility is too much
module.exports.CONNECTION_UNSTABLE_THRESHOLD = $c33e8340ba6e5159$var$CONNECTION_UNSTABLE_THRESHOLD;
class $c33e8340ba6e5159$var$ConnectionMonitorService extends $c33e8340ba6e5159$var$_emitter.default {
    // To count disconnects and reconnects
    constructor(){
        super();
        $c33e8340ba6e5159$var$_defineProperty(this, "monitorCount", 0);
        $c33e8340ba6e5159$var$_defineProperty(this, "metrics", $c33e8340ba6e5159$var$_metrics.default.create("exc.core.services.ConnectionMonitorService"));
        $c33e8340ba6e5159$var$_defineProperty(this, "status", "connected");
        window.addEventListener("offline", ()=>this.raiseCount(true));
        window.addEventListener("online", ()=>this.raiseCount());
    }
    lowerCount() {
        this.monitorCount--; // If we are out of change events to process, then update the banner state
        if (!this.monitorCount) {
            if (!navigator.onLine) {
                this.metrics.event("ConnectionMonitor.offline", {
                    counter: this.monitorCount
                }, {
                    level: $c33e8340ba6e5159$var$_metrics.Level.ERROR
                });
                this.updateStatus("offline");
            } else {
                this.metrics.event("ConnectionMonitor.online", {
                    counter: this.monitorCount
                }, {
                    level: $c33e8340ba6e5159$var$_metrics.Level.WARN
                });
                this.updateStatus("connected");
            }
        }
    }
    raiseCount(disconnect = false) {
        setTimeout(()=>this.lowerCount(), $c33e8340ba6e5159$var$CONNECTION_UNSTABLE_THRESHOLD);
        this.monitorCount++;
        if (disconnect) {
            this.metrics.event("ConnectionMonitor.disconnect", {
                counter: this.monitorCount
            }, {
                level: $c33e8340ba6e5159$var$_metrics.Level.WARN
            });
            if (this.monitorCount >= $c33e8340ba6e5159$var$CONNECTION_FAILURE_THRESHOLD * 2 - 1) {
                // The network has disconnected and reconnected and disconnected enough
                // times within our rolling time window to be unstable
                this.metrics.event("ConnectionMonitor.unstable", {
                    counter: this.monitorCount
                }, {
                    level: $c33e8340ba6e5159$var$_metrics.Level.ERROR
                });
                this.updateStatus("unstable");
            }
        }
    }
    updateStatus(status) {
        // Check that this is an actual state change or we could reverse an action from the dismiss button
        if (this.status === status) // No change to emit
        return;
        this.status = status;
        this.emit(status);
    }
}
module.exports.ConnectionMonitorService = $c33e8340ba6e5159$var$ConnectionMonitorService;
var $c33e8340ba6e5159$var$_default = new $c33e8340ba6e5159$var$ConnectionMonitorService();
module.exports.default = $c33e8340ba6e5159$var$_default;

});

parcelRegister("cpSRd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DiscoveryService = module.exports.DiscoveryError = void 0;

var $jVeiz = parcelRequire("jVeiz");

var $jOW4N = parcelRequire("jOW4N");

var $4ua75 = parcelRequire("4ua75");

var $loe8n = parcelRequire("loe8n");

var $dDEjQ = parcelRequire("dDEjQ");

var $3Zpnv = parcelRequire("3Zpnv");

var $iJaYo = parcelRequire("iJaYo");

var $df0a65c40d52fc9b$var$_stringHash = $df0a65c40d52fc9b$var$_interopRequireDefault((parcelRequire("h9eEw")));

var $ctGaZ = parcelRequire("ctGaZ");

var $15j1u = parcelRequire("15j1u");

var $df0a65c40d52fc9b$var$_metrics = $df0a65c40d52fc9b$var$_interopRequireWildcard((parcelRequire("17AVh")));

var $df0a65c40d52fc9b$var$_SessionService = $df0a65c40d52fc9b$var$_interopRequireDefault((parcelRequire("7Jeo0")));
function $df0a65c40d52fc9b$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $df0a65c40d52fc9b$var$_getRequireWildcardCache = function() {
        return cache;
    };
    return cache;
}
function $df0a65c40d52fc9b$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $df0a65c40d52fc9b$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $df0a65c40d52fc9b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $df0a65c40d52fc9b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
// If cached entry is less than 15 minutes old, skip "stale-while-revalidate"
const $df0a65c40d52fc9b$var$FRESHNESS_THRESHOLD = 900000; // 15 minutes.
const $df0a65c40d52fc9b$var$STORAGE_KEY = "unifiedShellDiscovery";
const $df0a65c40d52fc9b$var$localCache = (0, $iJaYo.getLocalCache)($df0a65c40d52fc9b$var$STORAGE_KEY);
/**
 * Before we hash the Discovery payload, we need to transform non-string elements
 * of the payload to strings to ensure the hash will always map to the same value.
 *
 * The non-string keys are Active Product Context and IMS profile.
 * The object below contains their transformation into unique keys.
 */ const $df0a65c40d52fc9b$var$PAYLOAD_TRANSFORM = {
    activeProductContext: (apc)=>Object.keys(apc).map((serviceCode)=>`${serviceCode}:${apc[serviceCode].ident || ""}:${apc[serviceCode].owningEntity || ""}`).join(","),
    imsProfile: (imsProfile)=>imsProfile.userId
};
const $df0a65c40d52fc9b$var$getSid = ()=>(0, $dDEjQ.getBootstrap)().getSid() || "unknown";
class $df0a65c40d52fc9b$var$DiscoveryError extends Error {
    constructor(message, status, _errorInfo){
        super(message);
        $df0a65c40d52fc9b$var$_defineProperty(this, "errorInfo", void 0);
        $df0a65c40d52fc9b$var$_defineProperty(this, "status", void 0);
        this.errorInfo = _errorInfo;
        this.status = status;
    }
}
module.exports.DiscoveryError = $df0a65c40d52fc9b$var$DiscoveryError;
class $df0a65c40d52fc9b$var$DiscoveryService {
    constructor(){
        $df0a65c40d52fc9b$var$_defineProperty(this, "promises", {});
        $df0a65c40d52fc9b$var$_defineProperty(this, "metrics", $df0a65c40d52fc9b$var$_metrics.default.create("exc.core.services.DiscoveryService"));
        $df0a65c40d52fc9b$var$_defineProperty(this, "profileReducer", ({ account_type: account_type, authId: authId, countryCode: countryCode, displayName: displayName, email: email, emailVerified: emailVerified, first_name: first_name, job_function: job_function, last_name: last_name, name: name, preferred_languages: preferred_languages, session: session, userId: userId })=>({
                account_type: account_type,
                authId: authId,
                countryCode: countryCode,
                displayName: displayName,
                email: email,
                emailVerified: emailVerified,
                first_name: first_name,
                job_function: job_function,
                last_name: last_name,
                name: name,
                preferred_languages: preferred_languages,
                projectedProductContext: [],
                session: session,
                userId: userId
            }));
        $df0a65c40d52fc9b$var$_defineProperty(this, "findDomainFromContext", ({ org: org, projectedProductContext: projectedProductContext, subOrg: subOrg }, findHostFromContext)=>{
            let domain;
            const { getHostFromContext: getHostFromContext, useAdobeDomain: useAdobeDomain } = findHostFromContext;
            projectedProductContext.some(({ prodCtx: prodCtx })=>{
                const { serviceCode: serviceCode, owningEntity: owningEntity } = prodCtx; // Note: fulfillable_data may not be the location to find the information for future apps.
                // We may want to add an extra config in the future for where to check or otherwise
                // handle other cases.
                if (owningEntity !== org || serviceCode !== findHostFromContext.serviceCode) return;
                domain = getHostFromContext(prodCtx, subOrg);
                return domain;
            });
            if (domain && useAdobeDomain) {
                const domainPart = domain.slice(0, domain.lastIndexOf("."));
                const topLevelDomain = domain.slice(domain.lastIndexOf(".") + 1);
                if (domain.endsWith(`adobe.${topLevelDomain}`)) return domain;
                return `${domainPart}.adobe.${topLevelDomain}`;
            }
            return domain;
        });
    }
    /**
   * Adds a random request ID to the Discovery URL
   * @param {string} url - Discovery server URL
   * @returns {string} - Discovery server URL with random request ID added.
   * @private
   */ static addRequestId(url) {
        return (0, $jVeiz.addParamToUrl)(url, "requestId", Math.random().toString().split(".")[1]);
    }
    /**
   * Calculates discovery paths, including removal of unwanted query parameters.
   * @param {DiscoveryCacheConfig} cacheConfig - Discovery cache configuration
   * @param {DiscoveryOptions} options
   * @returns {[string, string]} fullPath and path
   * @private
   */ getDiscoveryPaths(cacheConfig, options) {
        const { removeParams: removeParams = [] } = cacheConfig || {};
        const { basePath: basePath } = options;
        const currentUrl = (0, $jVeiz.hashToPath)();
        const pathWithoutContext = (0, $jVeiz.getPathWithoutContext)(currentUrl).replace((0, $jVeiz.getPathWithoutContext)(basePath), "");
        let path = (0, $jVeiz.getPathWithoutTenant)(pathWithoutContext);
        const fullPath = (0, $jVeiz.getPathWithoutTenant)(currentUrl);
        removeParams.length && (path = (0, $jVeiz.removeQueryParamsFromPath)(path, removeParams));
        return {
            fullPath: fullPath,
            path: path
        };
    }
    /**
   * Returns base payload without paths.
   * @param {CoreContext} context - Context object
   * @returns Discovery Payload.
   */ getBasePayload(context) {
        const { activeProductContext: activeProductContext, imsOrg: imsOrg, imsProfile: imsProfile, locale: locale, tenant: tenant, subOrg: subOrg } = context;
        return {
            activeProductContext: activeProductContext,
            company: subOrg?.name || "",
            imsOrg: imsOrg,
            imsProfile: imsProfile,
            locale: locale,
            tenant: tenant
        };
    }
    /**
   * Returns the discovery options for a given application
   * @param app App Sandbox object
   * @returns Discovery options
   */ getDiscoveryOptions(app) {
        const { basePath: basePath, context: context, solutionConfig: solutionConfig } = app;
        const { appId: appId, sections: sections, serviceCode: serviceCode, session: sessionConfig } = solutionConfig;
        return {
            appEnv: (0, $loe8n.getAppEnvironment)(context, solutionConfig),
            appId: appId,
            basePath: basePath,
            history: (0, $3Zpnv.getHistoryType)(solutionConfig),
            sections: sections,
            serviceCode: serviceCode,
            sessionConfig: sessionConfig
        };
    }
    /**
   * Checks if the context has all data needed to generate discovery payload.
   * @param source - Solution discovery source definition
   * @param app App Sandbox object.
   * @returns true if all data needed to generate discovery payload is available.
   */ canGeneratePayload(source, app) {
        const { context: context, solutionConfig: { serviceCode: serviceCode } } = app;
        const { subOrg: subOrg } = context;
        const { payload: payloadKeys, requiredPayload: requiredPayload } = source;
        const payload = this.getBasePayload(context);
        const { activeProductContext: activeProductContext, imsOrg: imsOrg } = payload;
        const properties = requiredPayload || payloadKeys || [];
        for (const key of properties){
            if (![
                "fullPath",
                "path"
            ].includes(key) && !payload[key]) return false;
            if (key === "activeProductContext" && serviceCode && !(imsOrg && activeProductContext?.[serviceCode]?.owningEntity === imsOrg)) {
                imsOrg && this.metrics.event("Discovery.apcOrgMismatch", {
                    imsOrg: imsOrg,
                    owningEntity: activeProductContext?.[serviceCode]?.owningEntity
                }, {
                    level: $df0a65c40d52fc9b$var$_metrics.Level.WARN
                });
                return false;
            }
            if (key === "company" && !(imsOrg && subOrg?.owningEntity === imsOrg)) {
                imsOrg && this.metrics.event("Discovery.subOrgMismatch", {
                    imsOrg: imsOrg,
                    owningEntity: subOrg?.owningEntity
                }, {
                    level: $df0a65c40d52fc9b$var$_metrics.Level.WARN
                });
                return false;
            }
        }
        return true;
    }
    /**
   * Generates Discovery payload
   * @param {DiscoverySource} source - Solution discovery source definition
   * @param {DiscoveryPaths} paths - Discovery path & full path
   * @param {CoreContext} context - Context object
   * @returns {DiscoveryPayload} Discovery request payload
   * @private
   */ getDiscoveryPayload(source, paths, context) {
        const { cache: cache = {}, payload: properties = [] } = source;
        const { keepParams: keepParams = [], pathCacheMethod: pathCacheMethod = $jOW4N.PATH_CACHE_METHOD.CACHE_PATH } = cache;
        let { path: path } = paths;
        const { imsProfile: imsProfile } = context;
        if (pathCacheMethod !== $jOW4N.PATH_CACHE_METHOD.CACHE_PATH) {
            // Ignore the path completely, only keep specific query parameters (If configured).
            const url = new URL(`${window.location.origin}${path}`);
            path = (0, $jVeiz.filterSearchParams)(url.searchParams, keepParams);
        }
        const payload = {
            ...this.getBasePayload(context),
            ...paths,
            path: path
        };
        if (properties.length) {
            const reducedPayload = {};
            properties.forEach((key)=>reducedPayload[key] = payload[key]); // Copy the property or sub property from payload to reducedPayload
            if (source.reduceProfile && properties.includes("imsProfile")) reducedPayload.imsProfile = this.profileReducer(imsProfile);
            return reducedPayload;
        }
        return payload;
    }
    /**
   * Returns a unique key for given payload, achieved through a one way hash.
   * @param {DiscoveryPayload} payload - Discovery payload
   * @param {DiscoverySource} source - Discovery configuration
   * @param {string} userId - Core context userId
   * @param {string} appId - Application ID
   * @returns {string} key (hash)
   * @private
   */ getKey(payload, source, userId, appId) {
        const payloadForKey = {};
        const payloadToTransform = payload;
        const payloadKeys = source.requiredPayload || source.payload;
        Object.keys(payload).filter((key)=>payloadKeys.includes(key)).forEach((key)=>payloadForKey[key] = $df0a65c40d52fc9b$var$PAYLOAD_TRANSFORM[key] && payloadToTransform[key] ? $df0a65c40d52fc9b$var$PAYLOAD_TRANSFORM[key](payloadToTransform[key]) : payloadToTransform[key]);
        const discoveryInfo = JSON.stringify({
            payload: payloadForKey,
            source: source,
            userId: userId
        });
        const hash = (0, $df0a65c40d52fc9b$var$_stringHash.default)(discoveryInfo);
        return `${appId}-${hash}`;
    }
    getSkylineKey({ imsSessionId: imsSessionId }, source, appId) {
        return `${appId}-${(0, $df0a65c40d52fc9b$var$_stringHash.default)(JSON.stringify({
            payload: {
                imsSessionId: imsSessionId
            },
            source: source
        }))}`;
    }
    /**
   * Returns true if the given date is considered "fresh" (Recent).
   * @param {DiscoveryResponse|undefined} response - Discovery response
   * @param {boolean} sessionConfigured - Is session used with this discovery?
   * @returns true if fresh, false otherwise.
   * @private
   */ isFresh(response, sessionConfigured = false) {
        let expiryForFreshness = response.fulfilled + $df0a65c40d52fc9b$var$FRESHNESS_THRESHOLD;
        if (sessionConfigured && response.session && response.sessionExpires) // If we have a valid session, we don't want to rerun discovery before it expires.
        expiryForFreshness = response.sessionExpires;
        return expiryForFreshness > Date.now();
    }
    /**
   * Returns an existing response for a discovery request.
   * Looks at the cache first, and then at pending requests.
   * @param key - unique key (Provided by getKey)
   * @param skipCache - Skip cache (Used for new sessions)
   * @param cache - Discovery cache config
   * @returns existing response if available.
   * @private
   */ async getExistingResponse(key, skipCache, cache) {
        try {
            // Look for existing result (or pending result) in memory
            const existingPromise = this.promises[key];
            let response;
            let from = $jOW4N.DiscoveryResponseSource.DIRECT; // Look for cached result. Note localCache already verifies expiry.
            if (!skipCache) {
                response = await $df0a65c40d52fc9b$var$localCache.get(key);
                if (response && cache.limitToImsSession) {
                    const { session: session } = response;
                    if (session !== $df0a65c40d52fc9b$var$getSid()) response = undefined;
                }
                from = $jOW4N.DiscoveryResponseSource.CACHE;
            } // If no cached, use a pending response if we have one.
            if (existingPromise && !response) {
                response = await existingPromise;
                from = $jOW4N.DiscoveryResponseSource.MEMORY;
            }
            if (response) return {
                from: from,
                response: response
            };
        } catch (err) {
            this.metrics.warn("Failed to get Discovery response from cache or memory", {
                err: err
            });
        }
    }
    getSectionFromResponse(response, options) {
        if (options.sections && response.url) {
            const url = new URL(response.url);
            return options.sections.find((section)=>url.pathname.startsWith(section.route));
        }
    }
    /**
   * Augment Path with URL by copying the origin and query parameters from the URL onto the path.
   * @param path - Path to augment
   * @param url - Input URL
   * @param method - Path caching method.
   * @param history - SPA History config
   * @returns Output URL combining the original path with input URL origin and parameters
   */ augmentPathWithURL(path, url, method, { history: history = $ctGaZ.HISTORY.HISTORY }) {
        const inputUrl = new URL(url);
        const outputUrl = new URL(history === $ctGaZ.HISTORY.HASH && path && path !== "/" ? `#${path}` : path, inputUrl.origin);
        if (method === $jOW4N.PATH_CACHE_METHOD.CACHE_PARAMS) // Copy origin and query params from input url.
        inputUrl.searchParams.forEach((value, name)=>outputUrl.searchParams.set(name, value));
        if (method === $jOW4N.PATH_CACHE_METHOD.CACHE_DEFAULT_PATH) {
            // If path is empty, copy the entire URL, otherwise copy origin only.
            if (!path || path === "/") return url;
        }
        return outputUrl.toString();
    }
    async needNewDiscoveryForSession(response, source, context, options, isCache) {
        const { appId: appId } = options;
        const section = this.getSectionFromResponse(response, options);
        if (section && response.url) {
            const { sessionParameter: sessionParameter } = section;
            if (sessionParameter) {
                const session = await $df0a65c40d52fc9b$var$_SessionService.default.getSession(context, options);
                if (!session) {
                    if (isCache) // No usable session. We need to do this again with cache disabled.
                    return true;
                     // This should not happen as the discovery endpoint is expected to return a session.
                    // Report this.
                    this.metrics.event("Discovery.sessionMissing", {
                        appId: appId,
                        discovery: source.discovery
                    }, {
                        level: $df0a65c40d52fc9b$var$_metrics.Level.ERROR
                    });
                }
                if (session) response.url = (0, $jVeiz.addParamToUrl)(response.url, sessionParameter, session.id);
            }
        }
        return false;
    }
    /**
   * Executes a discovery request.
   * @param {DiscoverySource} source - Solution discovery source definition
   * @param {CoreContext} context - Context object
   * @param {DiscoveryOptions} options - Additional discovery options
   * @returns {DiscoveryResponse} Discovery response
   */ async getSourceFromDiscovery(source, context, options) {
        const { appId: appId } = options;
        const { cache: cache = {
            scope: $jOW4N.CACHE_SCOPE.NONE
        }, findHostFromContext: findHostFromContext } = source;
        const { pathCacheMethod: pathCacheMethod = $jOW4N.PATH_CACHE_METHOD.CACHE_PATH } = cache;
        const paths = this.getDiscoveryPaths(cache, options);
        let payload = this.getDiscoveryPayload(source, paths, context);
        const discoveryTimer = this.metrics.start("Discovery");
        const key = (0, $15j1u.isSkyline)() ? this.getSkylineKey(context, source, appId) : this.getKey(payload, source, context.imsProfile?.userId, appId);
        let host = ""; // Populating host of discovery call if needed.
        if (findHostFromContext) {
            const { imsOrg: imsOrg, imsProfile: imsProfile, subOrg: subOrg } = context;
            host = this.findDomainFromContext({
                org: imsOrg,
                projectedProductContext: imsProfile?.projectedProductContext,
                subOrg: subOrg
            }, findHostFromContext);
            payload = {};
        }
        try {
            const { path: path = "" } = paths;
            let extraLogging = {};
            let isFresh = false;
            const sessionRequest = options.sessionRequest && source.includesSession;
            let { from: from, response: response } = await this.getExistingResponse(key, !!sessionRequest, cache) || {};
            if (response) {
                const { expires: expires, fulfilled: fulfilled } = response;
                let cachedSession;
                if (source.includesSession) {
                    cachedSession = await $df0a65c40d52fc9b$var$_SessionService.default.getSession(context, options);
                    if (cachedSession) {
                        response.session = cachedSession.id;
                        response.sessionExpires = cachedSession.expires;
                    }
                }
                isFresh = cache.scope === $jOW4N.CACHE_SCOPE.NONE || this.isFresh(response, source.includesSession);
                extraLogging = {
                    expires: expires,
                    fulfilled: fulfilled,
                    isFresh: isFresh
                };
            }
            from = from || $jOW4N.DiscoveryResponseSource.DIRECT; // If we don't have a response yet, or it is not recent - Get fresh.
            if (!(response && isFresh)) {
                const getDiscovery = ()=>{
                    const discoveryPromise = this.fetchDiscovery(source, payload, context).then((discoveryResponse)=>$df0a65c40d52fc9b$var$_SessionService.default.getSessionFromResponse(discoveryResponse, source, context, options)).then((discoveryResponse)=>this.onComplete(key, discoveryResponse, cache));
                    const logError = !!response;
                    this.promises[key] = discoveryPromise; // This method will log errors if waiting for the promise.
                    // Otherwise, onError will do it.
                    discoveryPromise.catch((error)=>{
                        logError && this.onError(key, source, error);
                    }).finally(()=>delete this.promises[key]);
                    return discoveryPromise;
                }; // If we have no response, wait for this promise.
                // Otherwise, it used for a future request (stale-while-revalidate)
                response = await (0, $3Zpnv.staleWhileRevalidate)(getDiscovery, response);
            } // Clone the response so any downstream code will not manipulate it directly.
            response = {
                host: host,
                ...response
            }; // Update URL if needed.
            if (response.url && pathCacheMethod !== $jOW4N.PATH_CACHE_METHOD.CACHE_PATH) response.url = this.augmentPathWithURL(path, response.url, pathCacheMethod, options);
             // Does this discovery include a session? Needs special handling then.
            if (source.includesSession && options.sections) {
                const needNewDiscovery = await this.needNewDiscoveryForSession(response, source, context, options, from === $jOW4N.DiscoveryResponseSource.CACHE);
                if (needNewDiscovery) // No usable session. We need to do this again with cache disabled.
                return this.getSourceFromDiscovery(source, context, {
                    ...options,
                    sessionRequest: true
                });
            }
            const { activeProductContext: activeProductContext, imsOrg: imsOrg, tenant: tenant } = payload;
            const fromString = from !== $jOW4N.DiscoveryResponseSource.DIRECT ? `.${from}` : "";
            const successEvent = `success${sessionRequest ? ".session" : ""}${fromString}`;
            discoveryTimer.time(successEvent, {
                ...extraLogging,
                activeProductContext: activeProductContext,
                appId: appId,
                imsOrg: imsOrg,
                path: payload.path,
                response: response,
                tenant: tenant,
                url: response.discoveryUrl
            });
            if (source.next && response.url) {
                const nextSource = {
                    ...source.next
                };
                const { origin: origin } = new URL(response.url);
                nextSource.discovery = nextSource.discovery.replace("{lastOrigin}", origin);
                return this.getSourceFromDiscovery(nextSource, context, options);
            }
            return response;
        } catch (error) {
            const message = error?.message || "Unknown error";
            const url = error?.url || source.discovery;
            discoveryTimer.time("error", {
                appId: appId,
                cookie: document.cookie.length,
                error: error?.errorInfo,
                message: message,
                url: url
            }, {
                level: $df0a65c40d52fc9b$var$_metrics.Level.ERROR
            }); // If the error is a DiscoveryError, it means there is more information to
            // be used by the caller function.
            if (error instanceof $df0a65c40d52fc9b$var$DiscoveryError) throw error;
            const discoveryError = new Error(`Failed to fetch url: ${message}`);
            discoveryError.status = error?.status;
            throw discoveryError;
        }
    }
    async extractDiscoveryError(response, source) {
        let errorContent = await response.text();
        const status = response.status;
        try {
            let error = JSON.parse(errorContent);
            if (error.errorDescription) errorContent = error.errorDescription;
             // Get app-specific error information from the error message if the app is
            // participating in this feature (e.g. the getErrorInfo function exists).
            if (source.getErrorInfo) error = {
                ...error,
                ...source.getErrorInfo(error)
            };
            return new $df0a65c40d52fc9b$var$DiscoveryError(`Status: ${response.status} Response: ${errorContent}`, status, error);
        } catch  {
            return new $df0a65c40d52fc9b$var$DiscoveryError(`Status: ${response.status} Response: ${errorContent}`, status);
        }
    }
    async fetchDiscovery(source, payload, context) {
        let { discovery: url = "" } = source;
        let scope = $4ua75.FetchScope.AUTH;
        let body = JSON.stringify(payload);
        let headers = {
            "Content-Type": "application/json"
        };
        const { withCredentials: withCredentials = false, xApiKey: xApiKey } = source;
        source.requestId && (url = $df0a65c40d52fc9b$var$DiscoveryService.addRequestId(url));
        if (source.simpleRequest) {
            body = JSON.stringify({
                accessToken: context.imsToken,
                ...payload
            });
            headers = {};
            scope = $4ua75.FetchScope.NONE;
        }
        const metadata = {
            apiKey: xApiKey ? context.apiKey : ""
        };
        const init = {
            body: body,
            credentials: withCredentials ? "include" : "omit",
            headers: headers,
            metadata: metadata,
            method: "POST",
            scope: scope,
            totalFetchTime: 10000
        };
        const response = await (0, $4ua75.fetch)(url, init);
        if (response.ok) try {
            const discoveryResponse = await response.json();
            discoveryResponse.discoveryUrl = url;
            return discoveryResponse;
        } catch (err) {
            err.url = url;
            throw err;
        }
        throw await this.extractDiscoveryError(response, source);
    }
    /**
   * Caches a discovery response after its complete.
   * @param {string} key - Discovery key
   * @param {DiscoveryResponse} response - Discovery Response
   * @param {DiscoveryCacheConfig} cacheConfig - Application discovery cache config
   * @returns {DiscoveryResponse} response - Response augmented with expiry data.
   * @private
   */ onComplete(key, response, cacheConfig) {
        const { limitToImsSession: limitToImsSession, scope: scope, ttl: ttl } = cacheConfig;
        if (ttl) {
            const fulfilled = Date.now();
            const expires = fulfilled + ttl * 1000;
            response = {
                ...response,
                expires: expires,
                fulfilled: fulfilled
            }; // Don't cache session data.
            const cacheResponse = {
                ...response
            };
            delete cacheResponse.session;
            delete cacheResponse.sessionExpires;
            if (limitToImsSession) cacheResponse.session = $df0a65c40d52fc9b$var$getSid();
             // Currently support local storage only.
            if (scope === $jOW4N.CACHE_SCOPE.LOCAL && !cacheResponse.dontCache) {
                this.metrics.event("Discovery.cacheSet", {
                    expires: expires,
                    key: key
                });
                $df0a65c40d52fc9b$var$localCache.set(key, cacheResponse);
            }
        }
        return response;
    }
    /**
   * Logs an error for background, non-blocking discovery failures.
   * @param {string} key
   * @param {DiscoverySource} source - Solution discovery source definition
   * @param {Error} error - Error information
   * @private
   */ onError(key, source, error) {
        const message = error && error.message || "Unknown error";
        const url = error.url ? error.url : source.discovery;
        this.metrics.event("Discovery.backgroundError", {
            cookie: document.cookie.length,
            key: key,
            message: message,
            url: url
        }, {
            level: $df0a65c40d52fc9b$var$_metrics.Level.ERROR
        });
    }
    async generateIframeSourceDiscovery(src, app) {
        const { context: context, metrics: appMetrics } = app;
        const { imsOrg: org, imsProfile: imsProfile, subOrg: subOrg } = context;
        const { findHostFromContext: findHostFromContext } = src;
        let host = "";
        try {
            // Populating host of discovery call if findHostFromContext is in config.
            // Host in URL would be templated in the config, and we need to find it in product context.
            if (findHostFromContext) {
                host = this.findDomainFromContext({
                    org: org,
                    projectedProductContext: imsProfile?.projectedProductContext,
                    subOrg: subOrg
                }, findHostFromContext) || "";
                host || appMetrics.event("Sandbox.generateIframeSource", "findHostFromContext could not determine host", {
                    org: org,
                    projectedProductContext: imsProfile?.projectedProductContext,
                    src: src,
                    subOrg: subOrg
                });
            }
            src = {
                ...src,
                discovery: (0, $loe8n.updateTemplatedURL)(src.discovery, app, {
                    host: host
                })
            };
            const discovery = await this.getSourceFromDiscovery(src, context, this.getDiscoveryOptions(app));
            const { client_id: client_id, scope: scopes, url: discoveryUrl } = discovery;
            const { defaults: defaults, url: url } = src;
            const urlString = discovery.url || url && (0, $loe8n.updateTemplatedURL)(url, app, {
                ...src,
                ...defaults || {},
                ...discovery
            });
            if (!urlString) return this.handleDiscoveryError(src, new Error("Discovery must either return a URL, or contain a URL in the configuration"), app);
            appMetrics.event("Sandbox.discoveryURL", {
                discovery: discovery,
                src: src,
                subOrg: subOrg
            });
            const customIms = client_id && scopes ? {
                client_id: client_id,
                scopes: scopes
            } : undefined;
            return {
                customIms: customIms,
                hasUrl: !!discoveryUrl,
                src: new URL(urlString)
            };
        } catch (err) {
            return this.handleDiscoveryError(src, err, app);
        }
    }
    handleDiscoveryError(source, discoveryError, app) {
        const { context: context, metrics: appMetrics, metricsAppId: appId, solutionConfig: solutionConfig } = app;
        const { message: message, status: status = 0 } = discoveryError || {};
        let error;
        if (!app.mounted) return {
            showErrorPage: false
        };
        appMetrics.event("Sandbox.discoveryFailed", {
            appId: appId,
            message: message
        }, {
            level: $df0a65c40d52fc9b$var$_metrics.Level.ERROR
        });
        if (source.redirectOnFailure) {
            const env = (0, $loe8n.getAppEnvironment)(context, solutionConfig);
            const { pageRedirect: pageRedirect, showToast: showToast, tenant: tenant } = context;
            const { redirectOnFailure: { code: code, path: path } } = source;
            appMetrics.event("Sandbox.discoveryFailureRedirect", {
                appId: appId,
                code: code,
                path: path,
                tenant: tenant
            });
            if (code.includes(status)) {
                const redirectConfig = {
                    env: env,
                    path: path,
                    replace: true,
                    tenant: tenant
                };
                if ((0, $15j1u.isSkyline)()) {
                    // For AEM Skyline, the redirect is to experience manager but
                    // then the user is taken to experience.adobe.com because
                    // non-Skyline apps can only load on experience.adobe.com. So a
                    // query param must be added so that experience cloud knows to
                    // show the toast.
                    const tempUrl = new URL(`${window.location.origin}${path}`);
                    tempUrl.searchParams.set("redirectToast", "instanceRedirectNoAccess");
                    redirectConfig.path = `${tempUrl.pathname}${tempUrl.search}`;
                } else // Non-Skyline should trigger a toast directly.
                showToast("instanceRedirectNoAccess");
                pageRedirect(redirectConfig);
                return {
                    showErrorPage: false
                };
            }
        } // If the errorInfo object exists on the error instance and the id is
        // set, the app has specific error information to be displayed to the
        // user. Setting the error state property means that it will be used
        // in `render()` to show the error message.
        if (discoveryError?.errorInfo?.id) {
            const { errorInfo: { description: description, heading: heading, id: id } } = discoveryError;
            error = {
                description: description,
                heading: heading,
                id: `${app.appId}.${id}`
            };
        }
        return {
            error: error,
            showErrorPage: true
        };
    }
}
module.exports.DiscoveryService = $df0a65c40d52fc9b$var$DiscoveryService;

});

parcelRegister("5pdfx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.handleGainsightRoles = module.exports.showRolesModalInvite = module.exports.showUserConsent = module.exports.displayTuxSurvey = void 0;

var $jBKJw = parcelRequire("jBKJw");

var $3j9cE = parcelRequire("3j9cE");

var $jVeiz = parcelRequire("jVeiz");

var $hCG2Z = parcelRequire("hCG2Z");

var $clGf1 = parcelRequire("clGf1");

var $cRLuS = parcelRequire("cRLuS");

var $ctGaZ = parcelRequire("ctGaZ");

var $iNslS = parcelRequire("iNslS");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // Updates to the user consent modal UI and legal language should include an
// update to this timestamp to ensure users see any updates
// Use new Date().toISOString().replace(/Z$/, '+00:00') to align with graphql
const $e27b024688d12440$var$LAST_USER_CONSENT_UPDATE = "2021-04-16T18:20:49.276+00:00";
const $e27b024688d12440$var$TWENTY_FOUR_HOURS = 86400000;
/**
 * Determine if Tux Survey should display
 */ const $e27b024688d12440$var$displayTuxSurvey = async ({ disabledApps: disabledApps, firstTimeUser: firstTimeUser, force: force, isLogin: isLogin, locale: locale, metrics: metrics, settings: settings, settingsService: settingsService, shellResponse: shellResponse, showToast: showToast, solutionConfig: solutionConfig, translationService: translationService })=>{
    // A unique visitor should not be given a TUX survey
    if (!force && firstTimeUser) metrics.info("TUX displayTuxSurvey, first time user set for TUX", {
        settings: settings
    }); // No return here, the value is passed to TUX to set a new quarantine date
     // Extract what we need from the solutionConfig
    const { appId: appId, appRoot: appRoot, parent: parent, releaseType: releaseType } = solutionConfig; // TUX surveys are scoped to the top level/parent app
    // In the future, we can add additional ids for API driven surveys
    // (i.e. `featureId` or `workflowId`)
    const topLevelApp = appRoot || appId; // TUX should NOT be triggered for apps in POC, Dev, Alpha, or Beta
    if (!force && releaseType && releaseType !== $ctGaZ.RELEASE_TYPE.GA) return metrics.info("TUX displayTuxSurvey early return, non-GA app", {
        releaseType: releaseType
    });
     // SKIP FOR QA/STAGE TESTING && RETURN FOR PROD RELEASE
    // TUX should only display on prod environment
    // Unless there is a force query param
    // if (!force && environment !== 'prod') {
    //   return metrics.info('TUX displayTuxSurvey early return, non-prod environment', {environment});
    // }
    const tuxConfig = {
        appId: appId,
        appParent: parent,
        appRoot: appRoot,
        disabledApps: disabledApps,
        firstTimeUser: firstTimeUser,
        force: force,
        isLogin: isLogin,
        locale: locale,
        releaseType: releaseType,
        settingsService: settingsService,
        showToast: showToast,
        topLevelApp: topLevelApp,
        translationService: translationService
    };
    const displayWidget = await (0, $3j9cE.displayTuxWidget)(tuxConfig, metrics); // If the TUX survey SHOULD be shown, construct the
    // necessary props and config info for rendering
    if (displayWidget) {
        // Get the branding data from AppAssembly's shellResponse object
        const { landingpage: landingpage, services: services, solutions: solutions } = shellResponse;
        const brandingInfo = services.concat(solutions).find(({ appId: id })=>topLevelApp === id);
        return {
            brandingInfo: brandingInfo || landingpage,
            ...tuxConfig
        };
    } // If the TUX survey should NOT be shown, we return nothing
};
/**
 * Import and show the User Consent form
 */ module.exports.displayTuxSurvey = $e27b024688d12440$var$displayTuxSurvey;
const $e27b024688d12440$var$showUserConsent = async ({ hide: hide, isLogin: isLogin, locale: locale, metrics: metrics, onSubmit: onSubmit, setSetting: setSetting, settings: settings, showToast: showToast, userConsentResponse: userConsentResponse, userConsentShown: userConsentShown })=>{
    const forceUserConsent = (0, $hCG2Z.getQueryValue)("forceuserconsent") === "true"; // Early return (to avoid unnecessary GraphQl call) if:
    // 1. Settings are not present AND the query param is NOT present
    // 2. The user is on the preferences page, because a user can open the preferences
    // page from the user consent modal and we don't want to show it again in that case
    if (!forceUserConsent && !settings || (0, $jVeiz.getPathWithoutTenant)((0, $jVeiz.hashToPath)()) === "/preferences") return;
     // We pass through userConsentDismissed count from settings if it exists
    const { userConsentDismissed: userConsentDismissed = 0 } = settings || {}; // If the user dismissed UserConsent with the Ask Me Later button, they
    // will have a userConsentDismissed count. Only show the dialog on login,
    // unless the user is using the force query param. We check the value of
    // userConsentShown in case the dialog was just shown (i.e. org switching
    // use case where isLogin is still true).
    if (userConsentDismissed > 0 && !isLogin && !forceUserConsent || userConsentShown) return;
     // The Shell init query retrieves the last update timestamp from the settings service.
    // If the user completed a Product Usage Consent after the last update,
    // we won't need to show the consent form.
    const { last_update_dts: lastUpdateDtsSettings } = settings?.userConsent || {};
    if (!forceUserConsent && lastUpdateDtsSettings && lastUpdateDtsSettings >= $e27b024688d12440$var$LAST_USER_CONSENT_UPDATE) return;
     // We care about their geolocation for the User Consent form
    // Ping azure front door to get it
    const azurePingResult = await (0, $jBKJw.checkCDN)();
    const isUnitedStatesUser = azurePingResult && azurePingResult.country === "us"; // If the user has not completed a Product Usage Consent form before
    // Or it's older than the last update, we need to show one
    let last_update_dts = "", permissions = [], showConsent = false;
    try {
        ({ last_update_dts: last_update_dts = "", permissions: permissions = [] } = userConsentResponse || (await (0, $clGf1.getUserConsent)()).getConsentPermissions);
        showConsent = !last_update_dts || last_update_dts < $e27b024688d12440$var$LAST_USER_CONSENT_UPDATE;
    } catch (error) {
        metrics.error("Failed to retrieve user consent permissions from GQL");
    } // Early return if the user has already submitted recent persmissions
    // AND the query param is NOT present
    if (!showConsent && !forceUserConsent) return;
    return {
        hide: hide,
        isUnitedStatesUser: isUnitedStatesUser,
        lastUpdate: last_update_dts,
        locale: locale,
        onSubmit: onSubmit,
        permissionsResponse: permissions,
        setSetting: setSetting,
        showToast: showToast,
        userConsentDismissed: userConsentDismissed
    };
};
module.exports.showUserConsent = $e27b024688d12440$var$showUserConsent;
const $e27b024688d12440$var$shouldShowByApp = (appId, featureFlags)=>{
    // Should change to switch statement once roles survey is on 3 apps
    if (appId === "experiencePlatformUI-home") return featureFlags?.["enable-roles-modal"] === "true" && /\/platform(\/home)?\/?$/.test(window.location.hash);
    else if (appId === "platformAnalytics") return featureFlags?.["cja-roles-dialog-enabled"] === "true" && /\/workspace(\/projects)?$/.test(window.location.hash);
};
const $e27b024688d12440$var$showRolesModalInvite = async ({ featureFlags: featureFlags, metrics: metrics, setSetting: setSetting, settings: settings, showRolesInvite: showRolesInvite, solutionConfig: solutionConfig })=>{
    if (!settings || !solutionConfig?.appId) // return early if the required data hasn't loaded yet
    return;
    const forceShow = (0, $hCG2Z.getQueryValue)("forcerolesmodal") === "true";
    if (!forceShow && !$e27b024688d12440$var$shouldShowByApp(solutionConfig.appId, featureFlags)) // Return early if the feature isn't enabled or we're in the wrong app
    return;
    const { userRoles: userRoles = {}, userRolesTimeline: userRolesTimeline = {} } = settings;
    const { count: count = 0, latestTimestamp: latestTimestamp } = userRolesTimeline;
    const timeSinceToast = latestTimestamp ? new Date().getTime() - new Date(latestTimestamp).getTime() : 0;
    if (!forceShow && (userRoles.roles || count > 2 || timeSinceToast && timeSinceToast < $e27b024688d12440$var$TWENTY_FOUR_HOURS)) // Return early if one of the following:
    // 1. user's roles data has already been recorded
    // 2. we've shown the toast in less than 24 hours
    // 3. shown toast 3 times already
    return;
    await (0, $iNslS.wait)(2000);
    setSetting({
        userRolesTimeline: {
            count: count + 1,
            latestTimestamp: new Date().toISOString()
        }
    });
    metrics.analytics.trackEvent({
        action: "display",
        element: "toast: tell us about yourself",
        feature: "roles pilot",
        type: "invite",
        widget: {
            name: "roles pilot invite",
            type: "info get started invite"
        }
    });
    showRolesInvite && showRolesInvite();
};
module.exports.showRolesModalInvite = $e27b024688d12440$var$showRolesModalInvite;
const $e27b024688d12440$var$handleGainsightRoles = async (settings, submittedRoles)=>{
    const { userRoles: settingsRoles } = settings;
    const userRoles = submittedRoles || settingsRoles;
    if (!userRoles?.roles) return;
     // submittedRoles get priority because it means the roles have updated
    // userRoles coming from state mean this is on load/context for the solution
    const { objectives: objectives = [], other: other = "", roles: roles } = userRoles;
    const gainsightRoles = {
        roleJobFunction: {},
        rolePlatformObjective: {}
    };
    Object.values($cRLuS.ROLE_NAMES).forEach((r)=>gainsightRoles.roleJobFunction[r] = roles.includes(r));
    Object.values($cRLuS.OBJECTIVE_NAMES).forEach((o)=>{
        // If the objective is other, we include the text input string
        // Otherwise we use a boolean
        gainsightRoles.rolePlatformObjective[o] = o === "other" ? other : objectives.includes(o);
    });
    return {
        gainsightRoles: gainsightRoles,
        userRoles: userRoles
    };
};
module.exports.handleGainsightRoles = $e27b024688d12440$var$handleGainsightRoles;

});
parcelRegister("3j9cE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.displayTuxWidget = void 0;
function $65485a5d7a1f8009$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $65485a5d7a1f8009$var$_getRequireWildcardCache = function() {
        return cache;
    };
    return cache;
}
function $65485a5d7a1f8009$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $65485a5d7a1f8009$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ const $65485a5d7a1f8009$var$displayTuxWidget = async (props, metrics)=>{
    const { disabledApps: disabledApps, force: force, firstTimeUser: firstTimeUser, isLogin: isLogin, settingsService: settingsService, topLevelApp: topLevelApp } = props; // If there is a `forcetux` query param we ALWAYS show the tux survey
    // and we skip any checks on display logic (but `processtux` query
    // param still runs through display logic)
    if (force) return true;
     // If the current app is in the disabled list AND there is NO force,
    // skip all data fetching and rendering
    if (!force && disabledApps.split(",").includes(topLevelApp)) {
        metrics.info("TUX displayTuxWidget early return, application is on the disabled list", {
            topLevelApp: topLevelApp
        });
        return false;
    } // Otherwise use the survey service to determine if we need the UI
    const surveyService = (await Promise.resolve().then(function() {
        return (parcelRequire("6w2vs"));
    }).then((res)=>$65485a5d7a1f8009$var$_interopRequireWildcard(res))).default;
    return surveyService.shouldShowSurvey(topLevelApp, settingsService, isLogin, firstTimeUser);
};
module.exports.displayTuxWidget = $65485a5d7a1f8009$var$displayTuxWidget;

});
parcelRegister("6w2vs", function(module, exports) {

var $Ha5sG = parcelRequire("Ha5sG");
module.exports = $Ha5sG("8ldnw").then(()=>parcelRequire("4CTIc"));

});


parcelRegister("clGf1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setUserConsent = module.exports.getUserConsent = module.exports.SET_USER_CONSENT = module.exports.USER_CONSENT_QUERY = void 0;

var $apIgy = parcelRequire("apIgy");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ const $cb38451ae2c60966$var$USER_CONSENT_QUERY = `
  query getConsentPermissions {
    getConsentPermissions {
      last_update_dts
      permissions {
        name
        enabled
        last_update_dts
      }
    }
  }
`;
module.exports.USER_CONSENT_QUERY = $cb38451ae2c60966$var$USER_CONSENT_QUERY;
const $cb38451ae2c60966$var$SET_USER_CONSENT = `
  mutation setConsentPermissions($source: String!, $permissions: [ConsentPermissionInput!]!) {
    setConsentPermissions(source: $source, permissions: $permissions) {
      success
      errors
    }
  }
`;
module.exports.SET_USER_CONSENT = $cb38451ae2c60966$var$SET_USER_CONSENT;
const $cb38451ae2c60966$var$getUserConsent = ()=>(0, $apIgy.gqlQuery)($cb38451ae2c60966$var$USER_CONSENT_QUERY, undefined);
module.exports.getUserConsent = $cb38451ae2c60966$var$getUserConsent;
const $cb38451ae2c60966$var$setUserConsent = (consentRequest)=>(0, $apIgy.gqlQuery)($cb38451ae2c60966$var$SET_USER_CONSENT, consentRequest);
module.exports.setUserConsent = $cb38451ae2c60966$var$setUserConsent;

});


parcelRegister("aILFS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cOPHH = parcelRequire("cOPHH");

var $e1d0720291a0bd11$var$_FeatureFlagService = $e1d0720291a0bd11$var$_interopRequireDefault((parcelRequire("ctskw")));

var $dWXgy = parcelRequire("dWXgy");

var $5FoVO = parcelRequire("5FoVO");

var $7Hyk2 = parcelRequire("7Hyk2");
function $e1d0720291a0bd11$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ class $e1d0720291a0bd11$var$FloodgateService extends $e1d0720291a0bd11$var$_FeatureFlagService.default {
    constructor(){
        super($5FoVO.PROVIDERS.FLOODGATE, $cOPHH.FG_GRAPHQL_QUERY_DATA_KEY, $cOPHH.VALID_CLIENT_IDS);
        this.onboardedClientIds = $cOPHH.ONBOARDED_CLIENT_IDS;
    }
    /**
   * Cleans up the floodgate features flags response.
   * @param data - Array of feature flag objects
   * @returns A flattened object of projects with feature flag properties
   */ flattenFeatureFlags(data) {
        const flattenedFlags = {};
        data.forEach(({ clientId: clientId, featureFlags: featureFlags })=>{
            flattenedFlags[clientId] = {};
            featureFlags.forEach(({ features: features = [], featuresMeta: featuresMeta = [] })=>{
                features.forEach((f)=>flattenedFlags[clientId][f] = "true");
                featuresMeta.forEach(({ feature: feature, meta: meta })=>{
                    flattenedFlags[clientId][feature] = meta;
                });
            });
        });
        return flattenedFlags;
    }
    /**
   * A wrapping function to support the bulk API with a list of client ids
   * as well as clean up and sort the returned object
   * @param clientIds - Array of strings of client IDs
   * @param context - Current context object that includes options we need
   * @returns An object of client ids with flattened feature flags
   */ async getFeatureFlags(clientIds, context, config) {
        // In the case of Floodgate, we ensure there are client ids to fetch
        clientIds = this.validateProjectIds(clientIds); // If there are no client ids, return undefined
        if (!clientIds?.length) return undefined;
         // Get the feature flags
        return this.getFlagData($dWXgy.getFloodgateFeatureFlags, clientIds, context, undefined, config).then((flagData)=>(0, $7Hyk2.sortAndFilterFlags)(clientIds, flagData));
    }
    /**
   * Formats the options payload for the GraphQL request.
   * @param clientIds - Client ids
   * @param context - Core Context
   * @returns An object of client ids with context data
   * @public
   */ getProviderPayload(clientIds, context) {
        const { imsOrg: imsOrg, imsInfo: { imsProfile: imsProfile }, sandbox: sandbox } = context; // Construct the user context values first
        // These values must match the context keys in Floodgate
        const addCtx = [];
        for (const [key, value] of Object.entries($cOPHH.CONTEXT_VARIABLES_MAP)){
            const contextValue = context[key] ?? imsProfile?.[key]; // Internal is a boolean and can be false so we check that it is not undefined
            (contextValue || typeof contextValue === "boolean") && addCtx.push({
                key: value,
                value: contextValue
            });
        } // Add the sandbox values if they exist
        if (sandbox) for (const [key, value] of Object.entries($cOPHH.SANDBOX_VARIABLES_MAP)){
            let sandboxValue = sandbox && sandbox[key]; // Floodgate requires the type string to be all caps
            if (key === "type") sandboxValue = $5FoVO.SANDBOX_TYPES[sandboxValue];
            sandboxValue && addCtx.push({
                key: value,
                value: sandboxValue
            });
        }
         // Return the payload
        return {
            addCtx: addCtx,
            clientIds: clientIds,
            imsOrg: imsOrg
        };
    }
    /**
   * Checks context data to see if the required data is missing.
   * @param clientIds - Client ids
   * @param context - Core Context
   * @returns False if context has all data needed, true otherwise.
   */ isContextMissing(clientIds, context) {
        return this.isCoreContextMissing(context);
    }
}
var $e1d0720291a0bd11$var$_default = new $e1d0720291a0bd11$var$FloodgateService();
module.exports.default = $e1d0720291a0bd11$var$_default;

});
parcelRegister("cOPHH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VALID_CLIENT_IDS = module.exports.SANDBOX_VARIABLES_MAP = module.exports.CONTEXT_VARIABLES_MAP = module.exports.FG_GRAPHQL_QUERY_DATA_KEY = module.exports.ONBOARDED_CLIENT_IDS = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ const $b3456dca46b110c4$var$ONBOARDED_CLIENT_IDS = [
    "acp_ui_platform",
    "genstudio",
    "unified-shell"
];
module.exports.ONBOARDED_CLIENT_IDS = $b3456dca46b110c4$var$ONBOARDED_CLIENT_IDS;
const $b3456dca46b110c4$var$FG_GRAPHQL_QUERY_DATA_KEY = "fgFeatureFlags"; // Context value mapping for Floodgate
// Some are mandatory/common context variables (like 'region' and 'sandboxType')
// whereas others were created for Unified Shell (with the `dx` prefix)
module.exports.FG_GRAPHQL_QUERY_DATA_KEY = $b3456dca46b110c4$var$FG_GRAPHQL_QUERY_DATA_KEY;
const $b3456dca46b110c4$var$CONTEXT_VARIABLES_MAP = {
    authId: "dxAuthId",
    email: "dxEmail",
    internal: "dxInternal",
    locale: "dxLocale",
    name: "dxName",
    userId: "dxUserId"
};
module.exports.CONTEXT_VARIABLES_MAP = $b3456dca46b110c4$var$CONTEXT_VARIABLES_MAP;
const $b3456dca46b110c4$var$SANDBOX_VARIABLES_MAP = {
    name: "dxSandboxName",
    region: "region",
    type: "sandboxType"
};
module.exports.SANDBOX_VARIABLES_MAP = $b3456dca46b110c4$var$SANDBOX_VARIABLES_MAP;
const $b3456dca46b110c4$var$VALID_CLIENT_IDS = [];
module.exports.VALID_CLIENT_IDS = $b3456dca46b110c4$var$VALID_CLIENT_IDS;

});

parcelRegister("ctskw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dc11e89493923a95$var$_emitter = $dc11e89493923a95$var$_interopRequireDefault((parcelRequire("dJSrf")));

var $dc11e89493923a95$var$_metrics = $dc11e89493923a95$var$_interopRequireWildcard((parcelRequire("17AVh")));

var $3Zpnv = parcelRequire("3Zpnv");

var $dc11e89493923a95$var$_UnifiedShellSessionService = $dc11e89493923a95$var$_interopRequireDefault((parcelRequire("d5KeZ")));
function $dc11e89493923a95$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $dc11e89493923a95$var$_getRequireWildcardCache = function() {
        return cache;
    };
    return cache;
}
function $dc11e89493923a95$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $dc11e89493923a95$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $dc11e89493923a95$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $dc11e89493923a95$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/**
 * The FeatureFlagService
 */ class $dc11e89493923a95$var$FeatureFlagService extends $dc11e89493923a95$var$_emitter.default {
    constructor(provider, queryDataKey, validProjectIds){
        super();
        $dc11e89493923a95$var$_defineProperty(this, "fetched", new Set());
        $dc11e89493923a95$var$_defineProperty(this, "metrics", void 0);
        $dc11e89493923a95$var$_defineProperty(this, "provider", void 0);
        $dc11e89493923a95$var$_defineProperty(this, "queryDataKey", void 0);
        $dc11e89493923a95$var$_defineProperty(this, "onboardedClientIds", void 0);
        $dc11e89493923a95$var$_defineProperty(this, "serviceName", void 0);
        $dc11e89493923a95$var$_defineProperty(this, "validProjectIds", void 0);
        $dc11e89493923a95$var$_defineProperty(this, "promises", {});
        $dc11e89493923a95$var$_defineProperty(this, "emitChange", (response, forcibleProjectIds)=>{
            const data = {};
            forcibleProjectIds.forEach((key)=>key in response && (data[key] = response[key]));
            Object.keys(data).length && this.emit("change", data);
        });
        $dc11e89493923a95$var$_defineProperty(this, "getUnfetchedFlags", (projectIds, contextKey)=>projectIds.filter((id)=>!this.fetched.has(this.createKey(contextKey, id))));
        this.provider = provider;
        this.queryDataKey = queryDataKey;
        this.validProjectIds = validProjectIds;
        this.serviceName = `${this.provider.replace(" ", "")}Service`;
        this.metrics = $dc11e89493923a95$var$_metrics.default.create(`exc.core.services.${this.serviceName}`);
    }
    /**
   * Creates a key that includes the feature flags id and specific key info
   * @param contextKey - A string including the required user key info (org or org/sandbox)
   * @param projectId - Id to identify which feature flags have been fetched with which contexts
   * @returns A concatenated string including all the necessary key indicators
   * @private
   */ createKey(contextKey, projectId) {
        const providerKey = this.provider.replace(" ", "").toLowerCase();
        return projectId ? `${providerKey}/${contextKey}/${projectId}` : `${providerKey}/${contextKey}`;
    }
    /**
   * Emit the change event on the service to notify listeners of new data.
   * @param response - Flattened feature flags by id .
   * @param forcibleProjectIds - List of project ids that were forcibly fetched.
   */ /**
   * Returns an existing, cached response for feature flags.
   * Looks at the cache first, then at pending requests.
   * @param cacheKey - unique key set by the provider service (i.e. imsOrgId or imsOrgId/sandbox)
   * @returns An object of feature flags groups (projects or clients) with flattened feature flags
   * @private
   */ async getExistingResponse(cacheKey) {
        try {
            // Look for cached result and if there is one, return it
            // Otherwise, look for pending promise and return it
            return await $dc11e89493923a95$var$_UnifiedShellSessionService.default.get("featureFlags", null, cacheKey) || this.promises[cacheKey];
        } catch (err) {
            this.metrics.warn(`Failed to get ${this.provider} response from cache or memory`, {
                err: err
            });
        }
    }
    /**
   * Fetches feature flags based on the provider's unique checks and options.
   */ /**
   * Handles bulk request flow for feature flags by id, checking for a response
   * in cache or a pending promise. Otherwise fetches from GraphQL.
   * @param promise - The graphql promise to fetch feature flags from the correct provider
   * @param projectIds - Array of feature flag project or client ids to fetch
   * @param options - Context options to properly fetch data
   * @param contextKey - A string including the required user key info (org or org/sandbox, etc)
   * @returns An object of feature flags groups (projects or clients) with flattened feature flags
   * @public
   */ async getFlagData(fetchFeatureFlags, projectIds, options, forcibleProjectIds = [], config) {
        // The `contextKey` is a string with related context values, like org or sandbox,
        // that is formatted and used for tracking, fetching, and the cache
        const { imsOrg: imsOrg, sandbox: sandbox } = options;
        const contextKey = sandbox ? `${imsOrg}/${sandbox.name}/${sandbox.region}/${sandbox.type}` : imsOrg; // Whereas the `cacheKey` includes the provider and the contextKey
        // We use to cacheKey to check for existing responses in cache but
        // maintain the provider-less `contextKey` to construct the fetched set later on
        const cacheKey = this.createKey(contextKey); // Step one: Get and validate any existing data before fetching from GraphQL
        const response = await this.getExistingResponse(cacheKey); // If the force property is set, we should remove the requested projects
        // from the cache if they exist and are in the allowed forcible projects.
        config?.force && projectIds.filter((project)=>forcibleProjectIds.includes(project)).forEach((project)=>response && delete response[project]); // Validate that the response has all the data that's been requested
        const missingFlags = this.getUncachedFlags(projectIds, response) || []; // Validate requested flags are fetched at least once per page load
        const unfetchedFlags = this.getUnfetchedFlags(projectIds, contextKey) || []; // We don't need to go through the staleWhileRevalidate workflow
        // every single time. If we have a fully validated response, return it
        if (response && !missingFlags.length && !unfetchedFlags.length) return response;
         // Step two: If we don't have a fully validated response,
        // construct a list of project/client ids to fetch in the graphql promise
        // If the cache or promise response is missing data, don't return it
        // It could be an empty object when the API fetches it
        // We reassign `response` so we don't return an empty/partial response
        const validatedResponse = !missingFlags.length ? response : undefined; // Construct a list of project/client ids and payload options to fetch in the graphql
        // promise including missing and unfetched projects/clients this session
        projectIds = Array.from(new Set(missingFlags.concat(unfetchedFlags)));
        const payload = this.getProviderPayload(projectIds, options); // Step three: Construct a promise to fetch the data from the GraphQL API
        const getGraphQLPromise = async ()=>{
            const graphQLPromise = fetchFeatureFlags(payload).then((graphQLResponse)=>{
                // Our GraphQl package returns santized errors (and also handles Adobe io errors)
                if (graphQLResponse?.errors) this.logResponseErrors(contextKey, graphQLResponse.errors, projectIds);
                 // It's possible for the response to also include usable data
                // If there is data, use it, otherwise return an empty object
                if (!graphQLResponse?.[this.queryDataKey]) return {};
                const successResponse = this.processSuccessResponse(contextKey, graphQLResponse, projectIds); // Force the feature flags to change, which also emits an event for the change
                config?.force && this.emitChange(successResponse, forcibleProjectIds);
                return {
                    ...response,
                    ...successResponse
                };
            }).finally(()=>{
                delete this.promises[cacheKey];
            });
            this.promises[cacheKey] = graphQLPromise;
            return graphQLPromise;
        };
        return (0, $3Zpnv.staleWhileRevalidate)(getGraphQLPromise, validatedResponse);
    }
    /**
   * Gets the specific options payload for the GraphQL feature flags promise.
   */ /**
   * Validates the flags requested against those in a response.
   * @param projectIds - Array of ids for feature flags requested
   * @param response - Response of feature flags by id
   * @returns Ids for missing data from the response
   * @private
   */ getUncachedFlags(projectIds, response = {}) {
        const cachedFlagKeys = Object.keys(response);
        return projectIds.filter((key)=>!cachedFlagKeys.includes(key));
    }
    /**
   * Provider specific checks for required context values.
   */ /**
   * Checks context data to see if the required data is missing.
   * @param context - Core Context
   * @returns False if context has all data needed, true otherwise.
   */ isCoreContextMissing(context) {
        const { imsOrg: imsOrg, internal: internal, locale: locale } = context; // We want to check that internal is defined (not just false with !internal)
        // Our payload requires the following values
        return !imsOrg || typeof internal !== "boolean" || !locale;
    }
    /**
   * Logs an error for background, non-blocking GraphQL failures.
   * @param contextKey - String with context info type like ims org
   * @param errors - array or graphql errors
   * @param projectIds - array of project/client ids that failed to fetch
   * @private
   */ logResponseErrors(contextKey, errors, projectIds) {
        // The request failed for this key, so don't cache that response in the
        // fetched set. Now subsequent requests will re-fetch.
        projectIds.forEach((id)=>this.fetched.delete(this.createKey(contextKey, id)));
        const message = `GQL failed to fetch feature flags from ${this.provider}. ${errors.map((err)=>err.message).join(", ")}` || "Unknown error";
        this.metrics.event(`${this.serviceName}.backgroundError`, {
            message: message
        }, {
            level: $dc11e89493923a95$var$_metrics.Level.ERROR
        });
    }
    /**
   * Cleans up the response, caches and returns it.
   * @param contextKey - unique key for type of feature flag query
   * @param graphQLResponse - Multiple project response from GraphQl
   * @param projectIds - Array of requested project/client ids
   * @returns An object of project/client ids with flattened feature flags
   */ processSuccessResponse(contextKey, graphQLResponse, projectIds) {
        const flattenedFlags = this.flattenFeatureFlags(graphQLResponse?.[this.queryDataKey]);
        this.updateCache(contextKey, flattenedFlags, projectIds);
        return flattenedFlags;
    }
    /**
   * Handles caching reponses and tracking the recieved data this session.
   * @param contextKey - String with key data like ims org/sandbox
   * @param flags - Flattened feature flags by id
   * @param projectIds - array of project/client ids that failed to fetch
   * @public
   */ updateCache(contextKey, flags, projectIds) {
        // When a successful request is made to get the latest data - Add the key/id
        // pair to the fetched set so subsequent requests do not make additional requests
        projectIds.forEach((id)=>this.fetched.add(this.createKey(contextKey, id))); // Add to the cache and log event based on the provider and key
        const cacheKey = this.createKey(contextKey);
        $dc11e89493923a95$var$_UnifiedShellSessionService.default.update("featureFlags", flags, null, cacheKey, false);
        this.metrics.event(`${this.serviceName}.cacheUpdate`, {
            key: cacheKey
        });
        return flags;
    }
    /**
   * Validates the request ids against the valid ids for the provider.
   * Throws an error for requests (non bulk) that explicitly include
   * invalid ids.
   * @param projectIds - array of project/client ids
   * @returns Array of valid ids or an error
   * @public
   */ validateProjectIds(projectIds) {
        const allowAll = this.validProjectIds.length === 0; // Support bulk API with ['*'] request as we require the actual
        // ids for data fetching, caching, and response formatting at the end
        const fetchAll = projectIds.length === 1 && projectIds[0] === "*";
        if (fetchAll) projectIds = allowAll ? this.onboardedClientIds || [] : this.validProjectIds;
         // If there are no ids for this request, log an error
        if (!projectIds.length) {
            const message = "Missing request id";
            this.metrics.event(`Feature flag validation error`, {
                ids: projectIds,
                message: message
            }, {
                level: $dc11e89493923a95$var$_metrics.Level.ERROR
            });
        } // Validate the request includes only valid ids
        // This does NOT include bulk API queries with ['*']
        // this does NOT include queries that do not enforce a project list like Floodgate (allowAll)
        if (!allowAll && !fetchAll && !projectIds.every((id)=>this.validProjectIds.includes(id))) {
            const message = "Invalid request id";
            this.metrics.event(`Feature flag validation error`, {
                ids: projectIds,
                message: message
            }, {
                level: $dc11e89493923a95$var$_metrics.Level.ERROR
            });
            throw new Error(`${message} - ${projectIds.join(",")}`);
        }
        return projectIds;
    }
}
module.exports.default = $dc11e89493923a95$var$FeatureFlagService;

});

parcelRegister("dWXgy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getFloodgateFeatureFlags = module.exports.FLOODGATE_QUERY = void 0;

var $apIgy = parcelRequire("apIgy");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ const $3f5f28f02e8206a0$var$FLOODGATE_QUERY = `
query fgFeatureFlagsQuery($payload: FeatureFlagInput!) {
  fgFeatureFlags(payload: $payload) {
    clientId
    featureFlags {
      release
      features
      featuresMeta {
        feature
        meta
      }
      release
    }
    status
  }
}
`;
module.exports.FLOODGATE_QUERY = $3f5f28f02e8206a0$var$FLOODGATE_QUERY;
const $3f5f28f02e8206a0$var$getFloodgateFeatureFlags = (floodgatePayload)=>(0, $apIgy.gqlQuery)($3f5f28f02e8206a0$var$FLOODGATE_QUERY, {
        payload: floodgatePayload
    }, {
        ignoreErrorsOnPaths: [
            "fgFeatureFlags"
        ]
    });
module.exports.getFloodgateFeatureFlags = $3f5f28f02e8206a0$var$getFloodgateFeatureFlags;

});


parcelRegister("d81zq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getCapabilityWithIconUrl = module.exports.getCapabilityIcon = void 0;

var $98ed3d8a72877e3b$var$_capabilities = $98ed3d8a72877e3b$var$_interopRequireDefault((parcelRequire("jePGM")));

var $98ed3d8a72877e3b$var$_CapabilityIcons = $98ed3d8a72877e3b$var$_interopRequireDefault((parcelRequire("65qmM")));
function $98ed3d8a72877e3b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ const $98ed3d8a72877e3b$var$CAPABILITY_ICONS = $98ed3d8a72877e3b$var$_capabilities.default.map((capability)=>capability.icon);
const $98ed3d8a72877e3b$var$getCapabilityIcon = (icon)=>$98ed3d8a72877e3b$var$CAPABILITY_ICONS.includes(icon) ? `${$98ed3d8a72877e3b$var$_CapabilityIcons.default}#${icon}` : "";
module.exports.getCapabilityIcon = $98ed3d8a72877e3b$var$getCapabilityIcon;
const $98ed3d8a72877e3b$var$getCapabilityWithIconUrl = (capability)=>{
    const capabilityWithIconUrl = $98ed3d8a72877e3b$var$_capabilities.default.filter(({ id: id, displayName: displayName })=>capability === id || capability === displayName)[0];
    if (!capabilityWithIconUrl) return;
    return {
        capabilityId: capabilityWithIconUrl.id,
        iconUrl: $98ed3d8a72877e3b$var$getCapabilityIcon(capabilityWithIconUrl.icon)
    };
};
module.exports.getCapabilityWithIconUrl = $98ed3d8a72877e3b$var$getCapabilityWithIconUrl;

});
parcelRegister("65qmM", function(module, exports) {
module.exports = new URL("CapabilityIcons.186cd8e6.svg", import.meta.url).toString();

});


parcelRegister("giDZP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getPerformanceMarks = $acff7f9bfb2a7fb1$var$getPerformanceMarks;

var $c0cwc = parcelRequire("c0cwc");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ const $acff7f9bfb2a7fb1$var$navProperties = [
    "domInteractive",
    "fetchStart",
    "loadEventStart",
    "responseEnd"
];
/**
 * Gets navigation timing metrics from window.performance.
 * Done either through a navigation entry or the legacy timing record.
 * @param nav - Navigation performance entry
 * @param timing - Performance timing, legacy interface if entry not available.
 * @returns {{}|{navigation metrics}}
 */ function $acff7f9bfb2a7fb1$var$getNavigationTiming(nav, timing) {
    let finalNav = nav;
    if (!finalNav && timing.navigationStart) {
        // Use legacy timing object (Safari).
        const legacyNav = {
            ...timing,
            legacyTiming: true
        };
        $acff7f9bfb2a7fb1$var$navProperties.forEach((property)=>{
            if (legacyNav[property]) legacyNav[property] = legacyNav[property] - timing.navigationStart;
        });
        finalNav = legacyNav;
    }
    const { domInteractive: domInteractive, fetchStart: fetchStart, legacyTiming: legacyTiming, loadEventStart: loadEventStart, responseEnd: responseEnd } = finalNav;
    return {
        domInteractive: domInteractive,
        fetchStart: fetchStart,
        legacyTiming: legacyTiming,
        loadEventStart: loadEventStart,
        responseEnd: responseEnd
    };
}
/**
 * Extracts performance data from metrics sent by the iframe.
 * @param loadTimes - Performance timings
 * @param start - App load start timestamp
 * @param done Page done timestamp as recorded by iframe
 * @param iframe performance entries
 * @param timeOrigin iframe navigation start (Time origin) timestamp
 * @param timing iframe legacy timing object
 * @returns Performance metrics (key/value) object
 */ function $acff7f9bfb2a7fb1$var$addIframeMarks(loadTimes, { done: done = 0, entries: entries, timeOrigin: timeOrigin, timing: timing }, start = 0) {
    const { timing: shellTiming } = performance;
    const shellTimeOrigin = performance.timeOrigin || shellTiming.navigationStart;
    const frameTimeOrigin = timeOrigin || timing?.navigationStart;
    /*
    Since the Shell frame and iframe started navigations at different times,
    we need to normalize iframe times by adding the delta:
    iframe navigation time - shell frame navigation time.
   */ const originDelta = frameTimeOrigin - (shellTimeOrigin + start);
    const withDelta = (metric)=>metric + originDelta;
    if (shellTimeOrigin && originDelta > 0 && entries) {
        let nav;
        entries.forEach((entry)=>{
            const { duration: duration, entryType: entryType, startTime: startTime, name: name } = entry;
            if (entryType === "paint") loadTimes[`iframe-${name}`] = withDelta(startTime);
            else if (entryType === "navigation" && !nav) nav = entry;
            else if (entryType === "resource") {
                loadTimes.rt_script_start = withDelta(startTime);
                loadTimes.rt_script_end = withDelta(startTime + duration);
            } else if (!loadTimes[name] && /^rt/.test(name)) loadTimes[name] = withDelta(startTime);
        });
        loadTimes.rt_page_done = withDelta(done);
        const navTimings = $acff7f9bfb2a7fb1$var$getNavigationTiming(nav, timing);
        if (navTimings) {
            loadTimes.iframeFetchStart = withDelta(navTimings.fetchStart);
            loadTimes.iframeDomInteractive = withDelta(navTimings.domInteractive);
            loadTimes.iframeResponseEnd = withDelta(navTimings.responseEnd);
        }
    }
}
/**
 * Adds Unified Shell performance data.
 * @param loadTimes - Performance timings
 * @param start - App load start timestamp
 * @param src IFrame source
 */ function $acff7f9bfb2a7fb1$var$addShellPerformance(loadTimes, start, src) {
    const iframeEntries = performance.getEntries().filter(({ startTime: startTime })=>startTime > start).filter((e)=>/^us/.test(e.name) || e.name.includes("paint") || e.name.includes("/token?jslVersion=v2") || e.name === src && e?.initiatorType === "iframe");
    iframeEntries.forEach(({ duration: duration, initiatorType: initiatorType, name: name, startTime: startTime })=>{
        startTime -= start;
        if (initiatorType === "iframe") name = "us_iframe_loaded";
        if (name.includes("/token?jslVersion=v2")) {
            name = "us_check_token_start";
            loadTimes["us_check_token_end"] = startTime + duration;
        }
        if (!loadTimes[name]) loadTimes[name] = startTime;
    });
}
/**
 * Aggregates performance data before sending to EIM.
 * @param params - Performance parameters
 * @returns Performance metrics (key/value pairs).
 */ function $acff7f9bfb2a7fb1$var$getPerformanceMarks(params) {
    const { appDone: appDone, appId: appId, firstRender: firstRender, iframePerformance: iframeStr, lastAppId: lastAppId, spaAppId: spaAppId = "n/a", src: src = "", thunderbird: thunderbird, start: start = 0, version: version = "" } = params;
    const { region: region } = window.config || {};
    const baseData = {
        appId: appId,
        region: region,
        serviceWorker: (0, $c0cwc.isWorkerActivated)(),
        spaAppId: spaAppId,
        thunderbird: thunderbird,
        valid: true,
        version: version
    };
    try {
        const iframePerformance = JSON.parse(iframeStr || "{}");
        const us_page_done = performance.now() - start;
        let loadTimes = {
            rt_page_done: us_page_done,
            us_page_done: us_page_done
        };
        $acff7f9bfb2a7fb1$var$addShellPerformance(loadTimes, start, src.toString()); // Add iframe performance times
        if (iframePerformance) {
            $acff7f9bfb2a7fb1$var$addIframeMarks(loadTimes, iframePerformance, start);
            if (loadTimes.iframeFetchStart && loadTimes.iframeFetchStart < 0) baseData.valid = false;
        }
        if (firstRender) {
            // First app render in this session.
            // need to combine Unified Shell and App performance data.
            let loadType = loadTimes.us_shell_done ? "reload" : "post-login";
            const nav = performance.getEntriesByType("navigation")[0];
            loadTimes = {
                ...loadTimes,
                ...$acff7f9bfb2a7fb1$var$getNavigationTiming(nav, performance.timing)
            };
            loadTimes.us_shell_isloginflow_done && (loadTimes.us_shell_done = loadTimes.us_shell_isloginflow_done);
            if (!loadTimes.us_shell_done) return {
                ...baseData,
                error: "Page done before Shell done"
            };
            if (loadTimes.us_errormessage) // Override load type so we know that load contained an error as this will
            // mess up the performance numbers.
            loadType = `${loadType}-with-error`;
            return {
                ...baseData,
                loadTimes: loadTimes,
                loadType: loadType
            };
        } // Not first app load in session but first app load for this Sandbox instance.
        if (lastAppId && !appDone) return {
            ...baseData,
            lastAppId: lastAppId,
            loadTimes: loadTimes,
            loadType: "switch"
        };
         // Second (Or more) time this Sandbox instance has loaded its app.
        // As we can't pinpoint the exact timing when inner navigation starts,
        // not recording performance metrics in this case.
        return {
            ...baseData,
            loadType: "inner-nav"
        };
    } catch (err) {
        return {
            ...baseData,
            error: `Failed to get performance data: ${err}`
        };
    }
}

});

parcelRegister("kZsRr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a8c41d0eae8526b1$var$_FeatureFlagService = $a8c41d0eae8526b1$var$_interopRequireDefault((parcelRequire("ctskw")));

var $bPa83 = parcelRequire("bPa83");

var $3Zpnv = parcelRequire("3Zpnv");

var $jL1VJ = parcelRequire("jL1VJ");

var $5FoVO = parcelRequire("5FoVO");

var $7Hyk2 = parcelRequire("7Hyk2");
function $a8c41d0eae8526b1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ /**
 * Feature flag service for LaunchDarkly provider
 */ class $a8c41d0eae8526b1$var$LaunchDarklyService extends $a8c41d0eae8526b1$var$_FeatureFlagService.default {
    constructor(){
        super($5FoVO.PROVIDERS.LAUNCH_DARKLY, $bPa83.LD_GRAPHQL_QUERY_DATA_KEY, $bPa83.VALID_LAUNCH_DARKLY_PROJECTS);
    }
    /**
   * Cleans up the array of projects' features flags.
   * @param data - GraphQL feature flag response of flag data
   * @returns A flattened object of projects with feature flag properties
   */ flattenFeatureFlags(data) {
        const { projects: projects = [] } = data;
        const flattenedFlags = {}; // Go through each project's array of feature flags and set as objects
        projects.forEach(({ projectId: projectId, featureFlags: featureFlags })=>{
            flattenedFlags[projectId] = Object.fromEntries(featureFlags.map(({ name: name, value: value })=>[
                    name,
                    value
                ]));
        }); // Returned a flattened object
        return flattenedFlags;
    }
    /**
   * Checks context data to see if the required data is missing.
   * @param projectIds - LaunchDarkly project ids strings
   * @param context - Core Context
   * @returns False if context has all data needed, true otherwise.
   */ isContextMissing(projectIds, context) {
        const missingContext = this.isCoreContextMissing(context);
        if (missingContext) return missingContext;
        const { sandbox: sandbox } = context; // Some LaunchDarkly requests require a sandbox name string
        const sandboxRequired = projectIds.some((project)=>$bPa83.ORG_SANDBOX_PROJECTS.includes(project));
        return sandboxRequired && !sandbox;
    }
    /**
   * Formats the options payload for the GraphQL request.
   * @param projectIds - LaunchDarkly project ids strings
   * @param context - Core Context
   * @returns An object of project ids with context data
   * @public
   */ getProviderPayload(projectIds, context) {
        const { imsOrg: imsOrgId, imsInfo: { imsProfile: imsProfile }, internal: internal, locale: locale, sandbox: sandbox } = context; // Construct the graphql query options
        return {
            projectIds: projectIds,
            userData: {
                custom: {
                    imsOrgId: imsOrgId,
                    internal: internal,
                    locale: locale,
                    sandboxName: sandbox?.name,
                    sandboxRegion: sandbox?.region,
                    userHash: imsProfile?.email && (0, $3Zpnv.generateUserHash)(imsProfile.email)
                }
            }
        };
    }
    /**
   * A wrapping function to support the bulk API with a list of project ids
   * as well as clean up and sort the returned object
   * @param projectIds - Array of strings of project IDs or ['*'] for all
   * @param context - Current context object that includes options we need
   * @returns An object of project ids with flattened feature flags
   */ async getFeatureFlags(projectIds, context, config) {
        // Validate the project ids and if some are invalid
        // the base class throws an error just like before
        projectIds = this.validateProjectIds(projectIds); // If there are no project ids, return undefined
        if (!projectIds?.length) return undefined;
         // Get the feature flags
        return this.getFlagData($jL1VJ.getMultiProjectFeatureFlags, projectIds, context, $bPa83.FORCIBLE_PROJECTS, config).then((flagData)=>(0, $7Hyk2.sortAndFilterFlags)(projectIds, flagData));
    }
}
var $a8c41d0eae8526b1$var$_default = new $a8c41d0eae8526b1$var$LaunchDarklyService();
module.exports.default = $a8c41d0eae8526b1$var$_default;

});
parcelRegister("jL1VJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getMultiProjectFeatureFlags = module.exports.MULTIPLE_PROJECT_FEATURE_FLAGS_QUERY = void 0;

var $4ua75 = parcelRequire("4ua75");

var $apIgy = parcelRequire("apIgy");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ const $443e46c26a7691bc$var$MULTIPLE_PROJECT_FEATURE_FLAGS_QUERY = `
  query multipleProjectFeatureFlagsQuery($projectIds: [String], $userData: CustomUserOptions) {
    multiProjectFeatureFlags(projectIds: $projectIds, user: $userData) {
      user {
        key
        custom {
          locale
          sandboxName
          sandboxRegion
          imsOrgId
        }
      }
      projects {
        projectId
        featureFlags {
          name
          value
        }
      }
    }
  }
`;
module.exports.MULTIPLE_PROJECT_FEATURE_FLAGS_QUERY = $443e46c26a7691bc$var$MULTIPLE_PROJECT_FEATURE_FLAGS_QUERY;
const $443e46c26a7691bc$var$getMultiProjectFeatureFlags = (ldMultiProjectInput)=>(0, $apIgy.gqlQuery)($443e46c26a7691bc$var$MULTIPLE_PROJECT_FEATURE_FLAGS_QUERY, ldMultiProjectInput, {
        scope: $4ua75.FetchScope.SANDBOX
    });
module.exports.getMultiProjectFeatureFlags = $443e46c26a7691bc$var$getMultiProjectFeatureFlags;

});


parcelRegister("9LMog", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ldKJa = parcelRequire("ldKJa");

var $khMmQ = parcelRequire("khMmQ");

var $cef6c7d76c803701$var$_metrics = $cef6c7d76c803701$var$_interopRequireDefault((parcelRequire("17AVh")));

var $4z2Gh = parcelRequire("4z2Gh");

var $iNslS = parcelRequire("iNslS");
function $cef6c7d76c803701$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cef6c7d76c803701$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
const $cef6c7d76c803701$var$COOLDOWN_TIMEOUT = 10000;
const $cef6c7d76c803701$var$EVENT_TIMEOUT = 40000;
const $cef6c7d76c803701$var$SETTINGS_TIMEOUT = 5000;
class $cef6c7d76c803701$var$RecentsService {
    constructor(service, callback){
        $cef6c7d76c803701$var$_defineProperty(this, "activeRequest", false);
        $cef6c7d76c803701$var$_defineProperty(this, "dataPrefetchService", void 0);
        $cef6c7d76c803701$var$_defineProperty(this, "eventFetchTimeout", null);
        $cef6c7d76c803701$var$_defineProperty(this, "metrics", void 0);
        $cef6c7d76c803701$var$_defineProperty(this, "queuedContext", void 0);
        $cef6c7d76c803701$var$_defineProperty(this, "requestCooldown", null);
        $cef6c7d76c803701$var$_defineProperty(this, "reportToSettings", void 0);
        this.metrics = $cef6c7d76c803701$var$_metrics.default.create("exc.core.RecentsService");
        this.dataPrefetchService = service;
        this.reportToSettings = (0, $iNslS.throttleQueue)(()=>callback(Date.now()), $cef6c7d76c803701$var$SETTINGS_TIMEOUT);
    }
    /**
   * Get recents from the DataPrefetchService. Context is set separately so that
   * the `handleRecentsEvent` doesn't need to know about it.
   * @param context - User/org context of the request.
   * @returns Array of recents or empty if there is an error or missing context.
   */ async getRecents(context) {
        // If there is an active request or still in the cooldown period, queue the
        // context to be triggered once it's available.
        if (this.activeRequest || this.requestCooldown) {
            this.queuedContext = context;
            return;
        }
        try {
            this.activeRequest = true;
            const res = await this.dataPrefetchService.getData($4z2Gh.RECENTS_PREFETCH_KEY, context);
            this.activeRequest = false;
            return res.value;
        } catch (e) {
            this.metrics.error("Error fetching recents", e);
        } finally{
            this.requestCooldown = setTimeout(()=>{
                const ctx = this.queuedContext;
                this.queuedContext = undefined;
                this.requestCooldown = null;
                ctx && this.getRecents(ctx);
            }, $cef6c7d76c803701$var$COOLDOWN_TIMEOUT);
        }
    }
    /**
   * Handles recent events. A timeout is started upon receipt which is restarted
   * if it is called again before the timeout finishes.
   * @param event - The recents event data.
   * @param context - User/org context of the request.
   */ handleRecentsEvent(event, context) {
        this.reportToSettings();
        this.eventFetchTimeout && clearTimeout(this.eventFetchTimeout);
        this.eventFetchTimeout = setTimeout(()=>{
            this.getRecents(context);
            this.eventFetchTimeout = null;
        }, $cef6c7d76c803701$var$EVENT_TIMEOUT);
    }
    /**
   * Loads older recents
   * @param currentRecents - recents currently in state
   * @param cursor - cursor to fetch older
   * @returns - complete recent result with one page of older recents and next cursor
   */ async getOlderRecents(currentRecents, cursor) {
        const recentParams = {
            acrossSandbox: true,
            cursor: cursor
        };
        try {
            const result = await (0, $ldKJa.getRecents)(recentParams);
            const { cursor: newCursor = null, recents: olderRecents = [] } = result.recent || {};
            const dedup = $4z2Gh.recentsContract.refreshData?.dedup;
            const { recents: recents } = (0, $khMmQ.mergeValuesByUniqueId)({
                recents: currentRecents
            }, {
                recents: olderRecents
            }, dedup);
            return {
                cursor: newCursor,
                recents: recents
            };
        } catch (e) {
            this.metrics.error("Error fetching older recents", e);
            return {
                cursor: null,
                recents: currentRecents
            };
        }
    }
}
module.exports.default = $cef6c7d76c803701$var$RecentsService;

});

parcelRegister("2WCxj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setAccessOverrides = void 0;

var $dXqQN = parcelRequire("dXqQN");

var $bPa83 = parcelRequire("bPa83");

var $iJaYo = parcelRequire("iJaYo");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ const $e652d282864b8d96$var$setAccessOverrides = async ({ appAssemblyService: appAssemblyService, enabledState: enabledState, featureFlags: featureFlags, floodgateFlags: floodgateFlags, fiServiceCode: fiServiceCode, hashedAuthId: hashedAuthId, selectedImsOrg: selectedImsOrg, userFulfillableItems: userFulfillableItems })=>{
    // Check storage for enablement and data (need for page refresh)
    const storedOverrides = await $iJaYo.storage.local.get("accessOverrides");
    const userOverrides = storedOverrides?.[hashedAuthId] || {
        featureFlags: {},
        floodgate: {},
        fulfillableItems: {}
    }; // We only implement the overrides if they are currently enabled (toggle is on)
    if (enabledState || userOverrides.enableOverrides) {
        const { featureFlags: featureFlagsOverride, floodgate: floodgateFlagsOverride, fulfillableItems: fulfillableItems } = userOverrides; // Feature flags - Requires featureFlags from LaunchDarkly in state
        const activeFeatureFlags = featureFlags && (0, $dXqQN.mergeFeatureFlagsForShell)(featureFlagsOverride[$bPa83.SHELL_LD_PROJECT], featureFlags); // Floodgate flags - Requires floodgateFlags from Floodgate in state
        const activeFloodgateFlags = floodgateFlags && (0, $dXqQN.mergeFeatureFlagsForShell)(floodgateFlagsOverride["unified-shell"], floodgateFlags); // Update AppAssembly with the active feature flags
        activeFeatureFlags && appAssemblyService?.setFeatureFlags(activeFeatureFlags); // Fulfillable items - Requires a fiServiceCode, indicating we're in a solution
        // that uses fulfillable items
        const activeFulfillableItems = fiServiceCode && (0, $dXqQN.mergeFulfillableItemsForShell)(selectedImsOrg, fiServiceCode, userFulfillableItems, fulfillableItems[fiServiceCode]);
        activeFulfillableItems && appAssemblyService?.setFulfillableItems(activeFulfillableItems);
        return {
            accessOverridesEnabled: true,
            activeFeatureFlags: activeFeatureFlags,
            activeFloodgateFlags: activeFloodgateFlags,
            activeFulfillableItems: activeFulfillableItems || userFulfillableItems
        };
    }
};
module.exports.setAccessOverrides = $e652d282864b8d96$var$setAccessOverrides;

});

parcelRegister("gWRcI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ /* eslint-disable */ var $c56b555d5befdddb$var$_default = /((CPU[ +]OS|iPhone[ +]OS|CPU[ +]iPhone|CPU IPhone OS)[ +]+(15[_\.]6|15[_\.]([7-9]|\d{2,})|(1[6-9]|[2-9]\d|\d{3,})[_\.]\d+|16[_\.]0|16[_\.]([1-9]|\d{2,})|(1[7-9]|[2-9]\d|\d{3,})[_\.]\d+)(?:[_\.]\d+)?)|(OperaMini(?:\/att)?\/?(\d+)?(?:\.\d+)?(?:\.\d+)?)|(Opera\/.+Opera Mobi.+Version\/(73\.0|73\.([1-9]|\d{2,})|(7[4-9]|[8-9]\d|\d{3,})\.\d+))|(Opera\/(73\.0|73\.([1-9]|\d{2,})|(7[4-9]|[8-9]\d|\d{3,})\.\d+).+Opera Mobi)|(Opera Mobi.+Opera(?:\/|\s+)(73\.0|73\.([1-9]|\d{2,})|(7[4-9]|[8-9]\d|\d{3,})\.\d+))|(SamsungBrowser\/(20\.0|20\.([1-9]|\d{2,})|(2[1-9]|[3-9]\d|\d{3,})\.\d+))|(Edge\/(111(?:\.0)?|111(?:\.([1-9]|\d{2,}))?|(11[2-9]|1[2-9]\d|[2-9]\d\d|\d{4,})(?:\.\d+)?))|(HeadlessChrome((?:\/109\.0\.\d+)?|(?:\/109\.([1-9]|\d{2,})\.\d+)?|(?:\/(11\d|[2-9]\d\d|\d{4,})\.\d+\.\d+)?|(?:\/111\.0\.\d+)?|(?:\/111\.([1-9]|\d{2,})\.\d+)?|(?:\/(11[2-9]|1[2-9]\d|[2-9]\d\d|\d{4,})\.\d+\.\d+)?))|((Chromium|Chrome)\/(109\.0|109\.([1-9]|\d{2,})|(11\d|[2-9]\d\d|\d{4,})\.\d+|111\.0|111\.([1-9]|\d{2,})|(11[2-9]|1[2-9]\d|[2-9]\d\d|\d{4,})\.\d+)(?:\.\d+)?)|(Version\/(15\.6|15\.([7-9]|\d{2,})|(1[6-9]|[2-9]\d|\d{3,})\.\d+|16\.3|16\.([4-9]|\d{2,})|(1[7-9]|[2-9]\d|\d{3,})\.\d+)(?:\.\d+)?.*Safari\/)|(Firefox\/(102\.0|102\.([1-9]|\d{2,})|(10[3-9]|1[1-9]\d|[2-9]\d\d|\d{4,})\.\d+|111\.0|111\.([1-9]|\d{2,})|(11[2-9]|1[2-9]\d|[2-9]\d\d|\d{4,})\.\d+)\.\d+)|(Firefox\/(102\.0|102\.([1-9]|\d{2,})|(10[3-9]|1[1-9]\d|[2-9]\d\d|\d{4,})\.\d+|111\.0|111\.([1-9]|\d{2,})|(11[2-9]|1[2-9]\d|[2-9]\d\d|\d{4,})\.\d+)(pre|[ab]\d+[a-z]*)?)/;
module.exports.default = $c56b555d5befdddb$var$_default;

});

parcelRegister("bD3vr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UserInputService = void 0;

var $efa0fca9dbf258a4$var$_EventObserver = $efa0fca9dbf258a4$var$_interopRequireDefault((parcelRequire("fkM9n")));

var $iNslS = parcelRequire("iNslS");
function $efa0fca9dbf258a4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $efa0fca9dbf258a4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
class $efa0fca9dbf258a4$var$UserInputService {
    constructor(messageService, app){
        $efa0fca9dbf258a4$var$_defineProperty(this, "sendMessage", void 0);
        $efa0fca9dbf258a4$var$_defineProperty(this, "customFeedbackOn", false);
        $efa0fca9dbf258a4$var$_defineProperty(this, "secondary", void 0);
        $efa0fca9dbf258a4$var$_defineProperty(this, "handleUserInputEvent", (value)=>{
            // The target object is too large to include in the post message
            const { target: target, ...slimValue } = value; // Handle a11y skip menu actions - Except for secondary frames (i.e. SandboxInner)
            this.secondary || this.handleSkipMenuEvent(target, slimValue); // Handle customFeedback clicks
            if (this.customFeedbackOn && value.type === "click" && value.data?.className?.includes("spectrum-Shell-feedback-button")) this.sendMessage({
                type: $iNslS.Events.CUSTOM_FEEDBACK,
                value: slimValue
            });
            this.sendMessage({
                type: $iNslS.Events.USER_INPUT,
                value: slimValue
            });
        });
        $efa0fca9dbf258a4$var$_defineProperty(this, "handleSkipMenuEvent", (target, { keyCode: keyCode, type: type })=>{
            // Ensure this is a skip menu event. We check both
            // the target and it's parent in case it's a label
            // and the values we need are on the button instead
            /* eslint-disable-next-line max-len */ const skipAction = target.closest(".skipMenu-listItem"); // Early return is not a skip menu action
            if (!skipAction) return;
             // Get the data attribute for skip menu items
            const data = skipAction.getAttribute("data-skip-menu"); // Send focus on skip menu click, space or enter keypress
            if (type === "click" || keyCode === 13 || keyCode === 32) {
                if (data === "fallback") {
                    // Fall back to our iframe if the skip menu key is a fallback
                    // This also handles the Safari case where we have to use the iframe
                    // because Safari prevents programatic focusing
                    // (https://github.com/braintree/braintree-web/issues/490)
                    const main = document.querySelector('[id^="exc-app-sandbox-"]');
                    if (main) {
                        main.tabIndex = -1;
                        main.focus();
                        main.addEventListener("blur", ()=>main.removeAttribute("tabIndex"), {
                            once: true
                        });
                    }
                    return;
                } // Otherwise post a message with the skip item key
                return this.sendMessage({
                    type: $iNslS.Events.SKIP_MENU_FOCUS,
                    value: data
                });
            } // Escape key removes focus on skip menu
            if (keyCode === 27) document.activeElement.blur();
        });
        $efa0fca9dbf258a4$var$_defineProperty(this, "fetchSkipMenu", ()=>this.sendMessage({
                type: $iNslS.Events.SKIP_MENU_GET_LIST
            }));
        $efa0fca9dbf258a4$var$_defineProperty(this, "onAiMessage", (event)=>this.sendMessage({
                type: $iNslS.Events.AI_MESSAGE,
                value: event.detail
            }));
        $efa0fca9dbf258a4$var$_defineProperty(this, "onLeftNavClick", (event)=>this.sendMessage({
                type: $iNslS.Events.NAV_ITEM_CLICK,
                value: event.detail
            }));
        this.secondary = app.secondary || false;
        this.sendMessage = (message)=>messageService.sendMessage(message, app); // Reset skip menu when new sandbox is constructed unless its secondary (i.e. SandboxInner)
        if (!this.secondary) {
            document.dispatchEvent(new CustomEvent("skipMenuList", {
                detail: null
            }));
            document.addEventListener("aiMessageOutgoing", this.onAiMessage);
            document.addEventListener("getSkipMenu", this.fetchSkipMenu);
            document.addEventListener("onLeftNavClick", this.onLeftNavClick);
        }
        $efa0fca9dbf258a4$var$_EventObserver.default.on("keyboard", this.handleUserInputEvent);
        $efa0fca9dbf258a4$var$_EventObserver.default.on("click", this.handleUserInputEvent);
        $efa0fca9dbf258a4$var$_EventObserver.default.on("mouseup", this.handleUserInputEvent);
    }
    set customFeedback(feedback) {
        this.customFeedbackOn = feedback;
    }
    /**
   * This functon is handler for all events happening on the shell.
   * @param {Object} value The payload.
   */ unmount() {
        this.customFeedbackOn = false;
        $efa0fca9dbf258a4$var$_EventObserver.default.off("keyboard", this.handleUserInputEvent);
        $efa0fca9dbf258a4$var$_EventObserver.default.off("click", this.handleUserInputEvent);
        $efa0fca9dbf258a4$var$_EventObserver.default.off("mouseup", this.handleUserInputEvent); // Secondary frames (i.e. SandboxInner) are not listening to skip menu events.
        if (!this.secondary) {
            document.removeEventListener("aiMessageOutgoing", this.onAiMessage);
            document.removeEventListener("getSkipMenu", this.fetchSkipMenu);
            document.removeEventListener("onLeftNavClick", this.onLeftNavClick);
        }
    }
}
module.exports.UserInputService = $efa0fca9dbf258a4$var$UserInputService;

});


parcelRegister("gEbfo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "SettingsLevel", {
    enumerable: true,
    get: function() {
        return $bllbv.SettingsLevel;
    }
});
module.exports.default = void 0;

var $ihFuI = parcelRequire("ihFuI");

var $bllbv = parcelRequire("bllbv");
/*************************************************************************
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: Adobe permits you to use, modify, and distribute this file in
 * accordance with the terms of the Adobe license agreement accompanying
 * it. If you have received this file from a source other than Adobe,
 * then your use, modification, or distribution of it requires the prior
 * written permission of Adobe.
 **************************************************************************/ /**
 * APIs to get or set settings, preferences or configuration data that can be stored and retrieved
 * at an IMS user and/or an IMS org level. An app in unified shell can consume Settings service.
 *
 * To consume this API, add the following import to your code.
 *
 * ```typescript
 * import settings from '@adobe/exc-app/settings';
 * ```
 *
 * The default export is an object of type [SettingsApi](../interfaces/_settings_.settingsapi.md)
 *
 * API reference: [scroll down](#index)
 *
 * ### Sample code
 *
 * ```typescript
 * import settings, {SettingsLevel} from '@adobe/exc-app/settings';
 *
 * async function updateSettings(type: string, value: number) {
 *   const data = await settings.get({
 *     groupId: 'test-groupId',
 *     level: SettingsLevel.USER,
 *     settings: {key1: null}
 *   });
 *   data = data || {};
 *   data[type] = value;
 *   await settings.set({
 *     groupId: 'test-groupId',
 *     level: SettingsLevel.USER,
 *     settings: {key1: data}
 *   });
 * }
 * ```
 *
 * ### SettingsLevel
 *
 * Can be optionally specified to define the level at which settings are saved.
 *
 * * `SettingsLevel.USER` - use this level when you want to get/set settings per user.
 * * `SettingsLevel.USERORG` - should be used when settings are for user + org combination.
 * * `SettingsLevel.ORG` - use this level when you want to get/set settings per org.
 *
 * By default settings are saved at level `SettingsLevel.USERORG`. You can optionally override this
 * in the get/set API calls using the `level` parameter.
 *
 * ### Groups
 *
 * Apps can group their settings into different groups by different group IDs and keep multiple
 * settings in different groups. Apps are free to define their own groups for a particular selected
 * settings level.
 *
 * You can specify this in the get/set API calls using the `groupId` parameter.
 *
 * ### Sharing settings
 *
 * Set settingsAppId in the solution specific route configuration in order to share settings with
 * other applications.
 * @packageDocumentation
 * @module settings
 */ const $5a09c710e4e94d01$var$settings = {
    get: (params)=>(0, $ihFuI.getImpl)("settings")().get(params),
    set: (params)=>(0, $ihFuI.getImpl)("settings")().set(params)
};
var $5a09c710e4e94d01$var$_default = $5a09c710e4e94d01$var$settings;
module.exports.default = $5a09c710e4e94d01$var$_default;

});


//# sourceMappingURL=postAuth.34d8d4f8.js.map
